/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Case = {
  __typename: "Case",
  id: string,
  number: string,
  confidential: boolean,
  status: CaseStatus,
  description: string,
  longDescription: string,
  assignedTo?: User | null,
  contact?: User | null,
  commentsAll?: string | null,
  openedOn: string,
  updatedOn: string,
  closedOn?: string | null,
  locationNum?: string | null,
  fieldMutated?: string | null,
  requestedItem?: RITM | null,
  submissionDetails?:  Array<Option | null > | null,
  activityStream?:  Array<ActivityStreamEntry | null > | null,
  canRequestUpdate: boolean,
  willCloseOn?: string | null,
  isUnread?: boolean | null,
  promptTypes?: Array< CasePromptType | null > | null,
};

export enum CaseStatus {
  NEW = "NEW",
  OPEN = "OPEN",
  AWAITING_INFO = "AWAITING_INFO",
  CLOSED = "CLOSED",
  RESOLVED = "RESOLVED",
}


export type User = {
  __typename: "User",
  id: string,
  firstName: string,
  lastName?: string | null,
  fullName?: string | null,
  guid?: string | null,
  userName?: string | null,
  audience: Audience,
  personId?: string | null,
  photoURL?: string | null,
  photo?: string | null,
  mobilePhone?: string | null,
  email?: string | null,
  title?: string | null,
};

export enum Audience {
  TEAM_MEMBER = "TEAM_MEMBER",
  OPERATOR = "OPERATOR",
  STAFF = "STAFF",
  CONTRACTOR = "CONTRACTOR",
  UNKNOWN_AUDIENCE = "UNKNOWN_AUDIENCE",
  SYSTEM = "SYSTEM",
}


export type RITM = {
  __typename: "RITM",
  id?: string | null,
  number: string,
  requestOptions?:  Array<Option | null > | null,
};

export type Option = {
  __typename: "Option",
  label?: string | null,
  supportingLabels?: Array< string | null > | null,
  value?: string | null,
  filterSets?: Array< string | null > | null,
  matches?: Array< string | null > | null,
  hiddenMatches?: Array< string | null > | null,
};

export type ActivityStreamEntry = {
  __typename: "ActivityStreamEntry",
  id: string,
  caseId: string,
  text?: string | null,
  createdBy?: User | null,
  createdOn: string,
  locationNum?: string | null,
};

export type ActivityStreamComment = {
  __typename: "ActivityStreamComment",
  id: string,
  caseId: string,
  text?: string | null,
  createdBy?: User | null,
  createdOn: string,
  locationNum?: string | null,
  translatedText?: string | null,
};

export type ActivityStreamAttachment = {
  __typename: "ActivityStreamAttachment",
  id: string,
  caseId: string,
  text?: string | null,
  createdBy?: User | null,
  createdOn: string,
  locationNum?: string | null,
  downloadURL: string,
  fileName: string,
  mimeType: string,
};

export enum CasePromptType {
  VIEW_APPOINTMENT = "VIEW_APPOINTMENT",
  ITEM_RECEIVED = "ITEM_RECEIVED",
  ITEM_RECEIVED_NO_INSTALL = "ITEM_RECEIVED_NO_INSTALL",
  DISPATCH_TECHNICIAN = "DISPATCH_TECHNICIAN",
  PM_DISPATCH_TECHNICIAN = "PM_DISPATCH_TECHNICIAN",
}


export type CasePromptInput = {
  caseId: string,
  promptType: CasePromptType,
  variables?: Array< CasePromptVariable | null > | null,
};

export type CasePromptVariable = {
  id: string,
  value?: string | null,
};

export type SubmitCasePromptResponse = {
  __typename: "SubmitCasePromptResponse",
  success: boolean,
};

export enum NotificationType {
  EMAIL = "EMAIL",
}


export type FormVariable = {
  id: string,
  value?: string | null,
};

export type CaseIdentifier = {
  __typename: "CaseIdentifier",
  id: string,
  number: string,
};

export type MinorCaseType = {
  __typename: "MinorCaseType",
  id: string,
  number: string,
  locationNum: string,
};

export type SubmitFormResponseType = {
  __typename: "SubmitFormResponseType",
  id: string,
  number: string,
  confirmationMessages?: Array< string | null > | null,
};

export type AssetCaseType = {
  __typename: "AssetCaseType",
  id: string,
  number: string,
  description: string,
};

export enum Program {
  RESTAURANT_EXPERIENCE_VISIT = "RESTAURANT_EXPERIENCE_VISIT",
  STAFF_OPERATOR_RELATIONSHIP_PROGRAM = "STAFF_OPERATOR_RELATIONSHIP_PROGRAM",
}


export type AssetAlertStatusChangeInput = {
  id: string,
  action: AssetAlertAction,
  actor?: string | null,
};

export enum AssetAlertAction {
  CREATED = "CREATED",
  MARKED_PENDING = "MARKED_PENDING",
  CALLED = "CALLED",
  RESOLVED = "RESOLVED",
}


export type AssetAlert = {
  __typename: "AssetAlert",
  id: string,
  locationNum: string,
  locationName: string,
  action: AssetAlertAction,
  actor: string,
  createdOn: string,
  summary: string,
  deviceType: string,
  detail?:  Array<Option | null > | null,
};

export type AssetViewedInput = {
  id: string,
  tag?: string | null,
  serial?: string | null,
  locationNum: string,
};

export type UserEventInput = {
  eventType: string,
};

export type UserEventInfo = {
  __typename: "UserEventInfo",
  userGuid: string,
  eventType: string,
  count: number,
};

export type SupportQueueContext = {
  routingKey: string,
  mobilePhone: string,
  caseNumber: string,
};

export type UserEventFilter = {
  platforms?: Array< AppPlatforms | null > | null,
};

export enum AppPlatforms {
  MOBILE = "MOBILE",
  WEB = "WEB",
}


export type CreateServiceEventInput = {
  assetId: string,
  locationNum: string,
  serviceDate: string,
  issue?: string | null,
  resolution?: string | null,
  vendor?: string | null,
  technicianName?: string | null,
  costUSD?: string | null,
  attachments?: Array< AddAttachmentInput | null > | null,
};

export type AddAttachmentInput = {
  fileName: string,
};

export type ServiceEventCreated = {
  __typename: "ServiceEventCreated",
  id: string,
  attachments?:  Array<AttachmentUpload | null > | null,
};

export type AttachmentUpload = {
  __typename: "AttachmentUpload",
  fileName: string,
  uploadUrl: string,
  scheme: AttachmentScheme,
};

export enum AttachmentScheme {
  ASSET_API = "ASSET_API",
  SERVICE_NOW = "SERVICE_NOW",
}


export type DeleteServiceEventInput = {
  serviceEventId: string,
};

export type ServiceEventDeleted = {
  __typename: "ServiceEventDeleted",
  id: string,
};

export type DeleteServiceAttachmentsInput = {
  serviceEventId: string,
  attachmentsToDelete: Array< DeleteAttachmentInput | null >,
};

export type DeleteAttachmentInput = {
  fileName: string,
};

export type ServiceAttachmentsDeleted = {
  __typename: "ServiceAttachmentsDeleted",
  serviceEventId: string,
};

export type UpdateServiceEventInput = {
  id: string,
  serviceDate?: string | null,
  issue?: string | null,
  resolution?: string | null,
  vendor?: string | null,
  technicianName?: string | null,
  costUSD?: string | null,
  attachments?: Array< AddAttachmentInput | null > | null,
  attachmentsToDelete?: Array< DeleteAttachmentInput | null > | null,
};

export type ServiceEventUpdated = {
  __typename: "ServiceEventUpdated",
  id: string,
  attachments?:  Array<AttachmentUpload | null > | null,
};

export type SearchFeedbackInput = {
  query: string,
  resultContextType: SupportSearchContext,
  resultId: string,
  signal: SearchFeedbackSignal,
};

export enum SupportSearchContext {
  KB = "KB",
  FORM = "FORM",
  CASE = "CASE",
}


export enum SearchFeedbackSignal {
  CLICK = "CLICK",
}


export type CommentInput = {
  id: string,
  caseId: string,
  date: string,
  text: string,
  userId?: string | null,
  caseContactGuid?: string | null,
  locationNum: string,
  caseName: string,
  caseNumber: string,
  commenterFirstName: string,
  commenterPersonId?: string | null,
  commenterAudience?: string | null,
  commenterGuid?: string | null,
  confidential?: boolean | null,
};

export type ActivityStreamEntryWebSockets = {
  __typename: "ActivityStreamEntryWebSockets",
  id: string,
  caseId: string,
  text?: string | null,
  createdBy?: User | null,
  createdOn: string,
  locationNum: string,
  downloadURL?: string | null,
  fileName?: string | null,
  mimeType?: string | null,
};

export type AttachmentInput = {
  id: string,
  caseId: string,
  date: string,
  downloadURL: string,
  fileName: string,
  mimeType: string,
  userId?: string | null,
  caseContactGuid?: string | null,
  locationNum: string,
  caseName: string,
  caseNumber: string,
  attacherFirstName: string,
  attacherPersonId?: string | null,
  attacherAudience?: string | null,
  attacherGuid?: string | null,
  confidential?: boolean | null,
};

export type CaseUpdateInput = {
  number: string,
  fieldMutated: string,
  caseContactGuid?: string | null,
  resolutionText?: string | null,
};

export type AnnouncementInput = {
  id: string,
  title?: string | null,
  summary?: string | null,
  url?: string | null,
  date?: string | null,
  category?: string | null,
  majorCaseId?: string | null,
  isActive?: boolean | null,
  updatedOn?: string | null,
  createdOn?: string | null,
  startedOn?: string | null,
  expiredOn?: string | null,
};

export type Announcement = {
  __typename: "Announcement",
  id: string,
  title?: string | null,
  summary?: string | null,
  category: AnnouncementCategory,
  updatedOn: string,
  hasBeenUpdated?: boolean | null,
  url?: string | null,
  outagePageURL?: string | null,
  majorCaseId?: string | null,
  isUnread: boolean,
  isExpired: boolean,
};

export enum AnnouncementCategory {
  NORMAL = "NORMAL",
  URGENT = "URGENT",
}


export type CaseReminderInput = {
  id: string,
  number: string,
  description: string,
  caseContactGuid?: string | null,
  locationNum: string,
  confidential?: boolean | null,
};

export type AppointmentActivityInput = {
  appointmentId: string,
  taskNum?: string | null,
  activity: AppointmentActivity,
  subject: string,
  dueDate: string,
  locationTzId: string,
  locationName: string,
  locationNum: string,
  techName: string,
};

export enum AppointmentActivity {
  SCHEDULED = "SCHEDULED",
  UPDATED = "UPDATED",
  CANCELED = "CANCELED",
  TECHNICIAN_ARRIVED = "TECHNICIAN_ARRIVED",
  TECHNICIAN_TRAVELING = "TECHNICIAN_TRAVELING",
}


export type AssetAlertInput = {
  id: string,
  locationNum: string,
  locationName: string,
  action: AssetAlertAction,
  actor: string,
  createdOn: string,
  item: string,
  itemSpecs?: string | null,
  errorCode: string,
  errorDesc: string,
};

export type PaginatedCases = {
  __typename: "PaginatedCases",
  pageInfo?: Page | null,
  cases?:  Array<Case | null > | null,
};

export type Page = {
  __typename: "Page",
  totalItems?: number | null,
  totalPages?: number | null,
  hasNextPage?: boolean | null,
};

export type CasesRecentPayload = {
  __typename: "CasesRecentPayload",
  locationCasesRecent:  Array<CasesRecentRestaurant >,
};

export type CasesRecentRestaurant = {
  __typename: "CasesRecentRestaurant",
  locationNum: string,
  cases?:  Array<Case > | null,
};

export type CasePrompt = {
  __typename: "CasePrompt",
  id: string,
  // unique within the scope of the same case
  promptType: CasePromptType,
  title: string,
  description?: string | null,
};

export type CasePromptItemReceived = {
  __typename: "CasePromptItemReceived",
  id: string,
  promptType: CasePromptType,
  // ITEM_RECEIVED
  title: string,
  // ex: "Let us know your item has arrived"
  description?: string | null,
};

export type CasePromptViewAppointment = {
  __typename: "CasePromptViewAppointment",
  id: string,
  promptType: CasePromptType,
  // VIEW_APPOINTMENT
  title: string,
  // ex: "View Related Appointment"
  description?: string | null,
  // ex: "March 24 at 4:00PM"
  appointmentId: string,
};

export type CasePromptPMDispatchTechnician = {
  __typename: "CasePromptPMDispatchTechnician",
  id: string,
  promptType: CasePromptType,
  // PM_DISPATCH_TECHNICIAN
  title: string,
  // ex: "Dispatch my regular technician"
  description?: string | null,
};

export type CasePromptDispatchTechnician = {
  __typename: "CasePromptDispatchTechnician",
  id: string,
  promptType: CasePromptType,
  // DISPATCH_TECHNICIAN
  title: string,
  // ex: "Dispatch my regular technician"
  description?: string | null,
};

export type CasePromptItemReceivedNoInstall = {
  __typename: "CasePromptItemReceivedNoInstall",
  id: string,
  promptType: CasePromptType,
  // ITEM_RECEIVED_NO_INSTALL
  title: string,
  // ex: "Let us know your item has arrived"
  description?: string | null,
};

export type SupportCategory = {
  __typename: "SupportCategory",
  id: string,
  label?: string | null,
  description?: string | null,
  imageName?: string | null,
  url: string,
  form?: SupportCategoryForm | null,
  items?:  Array<SupportCategory | null > | null,
  featuredOrder?: number | null,
  recentlyFeaturedOrder?: number | null,
  commonlyUsedOrder?: number | null,
  recommendedOrder?: number | null,
  isFeatured?: boolean | null,
  labelAccoutrement?: string | null,
  caseCategory?: string | null,
};

export type SupportCategoryForm = {
  __typename: "SupportCategoryForm",
  id: string,
  minimumAppVersion?: string | null,
  introContents?: SupportCategoryFormIntro | null,
  showIntroOnLoad?: boolean | null,
  dynamicLayout?: boolean | null,
  caseCategory?: string | null,
  defaults?:  Array<FormEntryVariable | null > | null,
};

export type SupportCategoryFormIntro = {
  __typename: "SupportCategoryFormIntro",
  header?: string | null,
  body?:  Array<SupportCategoryFormIntroRow | null > | null,
};

export type SupportCategoryFormIntroRow = {
  __typename: "SupportCategoryFormIntroRow",
  text?: string | null,
  imageName?: string | null,
};

export type FormEntryVariable = {
  __typename: "FormEntryVariable",
  id: string,
  value?: string | null,
  displayValue?: string | null,
  description?: string | null,
  sensitive?: boolean | null,
};

export type SupportCategoryContext = {
  asset?: AssetContext | null,
};

export type AssetContext = {
  id?: string | null,
  tag?: string | null,
  serial?: string | null,
  locationNum?: string | null,
  typeId?: string | null,
  typeFamily?: string | null,
  modelId?: string | null,
  allowAdditionalEquipmentRequest?: boolean | null,
};

export type SupportContext = {
  __typename: "SupportContext",
  supportDeskPhoneNumber?: string | null,
  queue?: SupportQueue | null,
  assignedTo?: string | null,
};

export type SupportQueue = {
  __typename: "SupportQueue",
  isOpen: boolean,
  personsInQueueCount?: number | null,
  routingKey?: string | null,
};

export type CaseSubmissionRequest = {
  __typename: "CaseSubmissionRequest",
  number?: string | null,
  details?:  Array<Option | null > | null,
};

export type Article = {
  __typename: "Article",
  id: string,
  number: string,
  title: string,
  solutionContent?: string | null,
  visibility?: ArticleVisibility | null,
  preview?: string | null,
  searchQueryId?: string | null,
  searchResultId?: string | null,
};

export enum ArticleVisibility {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}


export type KBAnswers = {
  __typename: "KBAnswers",
  articlesFeatured?:  Array<Article | null > | null,
  articlesRecent?:  Array<Article | null > | null,
};

export type AirshipUserProperties = {
  __typename: "AirshipUserProperties",
  tagGroups?:  Array<AirshipTagGroup | null > | null,
  attributes?:  Array<Option | null > | null,
};

export type AirshipTagGroup = {
  __typename: "AirshipTagGroup",
  name: string,
  tags: Array< string | null >,
};

export type UserInfo = {
  __typename: "UserInfo",
  user: User,
  countryCode?: string | null,
};

export type Restaurant = {
  __typename: "Restaurant",
  id?: string | null,
  number: string,
  name?: string | null,
  contacts?:  Array<User | null > | null,
  siteProperties?: RestaurantSite | null,
  openCasesCount?: number | null,
  operator?: User | null,
  supportDeskPhoneNumber?: string | null,
};

export type RestaurantSite = {
  __typename: "RestaurantSite",
  lat?: number | null,
  long?: number | null,
  countryCode?: string | null,
  utcOffset?: string | null,
  tzId?: string | null,
};

export type StaffRestaurants = {
  __typename: "StaffRestaurants",
  type: StaffRestaurantsType,
  restaurants:  Array<Restaurant | null >,
};

export enum StaffRestaurantsType {
  RECENT = "RECENT",
  CONSULTANT = "CONSULTANT",
}


export type FormLayout = {
  __typename: "FormLayout",
  id: string,
  version?: number | null,
  title: string,
  usesAttachments?: boolean | null,
  confirmationMessages?: Array< string | null > | null,
  layout:  Array<FormLayoutStage | null >,
  variables:  Array<FormEntryVariable | null >,
  startingStage?: string | null,
  reloadOnLocationChange?: boolean | null,
};

export type FormLayoutStage = {
  __typename: "FormLayoutStage",
  id: string,
  title?: string | null,
  header?: string | null,
  footer?: string | null,
  groups?:  Array<FormLayoutGroup | null > | null,
  styles?:  Array<Option | null > | null,
  submissionFields?: Array< string | null > | null,
  required?: boolean | null,
  proceedOnAnyRequired?: boolean | null,
  visible?: boolean | null,
  supportingData?: string | null,
  nextStage?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FormLayoutVariant | null > | null,
  asides?:  Array<FormLayoutStageAside | null > | null,
};

export type FormLayoutGroup = {
  __typename: "FormLayoutGroup",
  id: string,
  header?: string | null,
  footer?: string | null,
  fields?:  Array<FormLayoutField | null > | null,
  styles?:  Array<Option | null > | null,
  submissionFields?: Array< string | null > | null,
  orientation?: FormLayoutOrientation | null,
  required?: boolean | null,
};

export type FormLayoutField = {
  __typename: "FormLayoutField",
  id: string,
  fieldType?: FormLayoutFieldType | null,
  visible?: boolean | null,
  align?: FormLayoutFieldAlignment | null,
  header?: string | null,
  footer?: string | null,
  footerEmphasized?: boolean | null,
  styles?:  Array<Option | null > | null,
  variesBasedOn?: string | null,
  variants?:  Array<FormLayoutVariant | null > | null,
  resetBasedOnAny?: Array< string > | null,
};

export type FormLayoutInteractionField = {
  __typename: "FormLayoutInteractionField",
  id: string,
  fieldType?: FormLayoutFieldType | null,
  visible?: boolean | null,
  align?: FormLayoutFieldAlignment | null,
  header?: string | null,
  footer?: string | null,
  footerEmphasized?: boolean | null,
  styles?:  Array<Option | null > | null,
  variesBasedOn?: string | null,
  variants?:  Array<FormLayoutVariant | null > | null,
  resetBasedOnAny?: Array< string > | null,
  usageInstructions?: string | null,
  required?: boolean | null,
};

export enum FormLayoutFieldType {
  SELECT = "SELECT",
  SELECT_SEARCH = "SELECT_SEARCH",
  MULTI_SELECT = "MULTI_SELECT",
  MULTI_SELECT_SEARCH = "MULTI_SELECT_SEARCH",
  PHONE = "PHONE",
  DATE = "DATE",
  TIME = "TIME",
  BOOL = "BOOL",
  TEXT = "TEXT",
  TEXT_TYPEAHEAD = "TEXT_TYPEAHEAD",
  DISPLAY_TEXT = "DISPLAY_TEXT",
  DISPLAY_TEXT_SIDE_BY_SIDE = "DISPLAY_TEXT_SIDE_BY_SIDE",
  DISPLAY_TEXT_TOTALS = "DISPLAY_TEXT_TOTALS",
  DISPLAY_TEXT_TABLE = "DISPLAY_TEXT_TABLE",
  ATTACHMENTS = "ATTACHMENTS",
}


export enum FormLayoutFieldAlignment {
  LEADING = "LEADING",
  TRAILING = "TRAILING",
  CENTER = "CENTER",
}


export type FormLayoutVariant = {
  __typename: "FormLayoutVariant",
  key: string,
  changes: FormLayoutVariantChanges,
};

export type FormLayoutVariantChanges = {
  __typename: "FormLayoutVariantChanges",
  header?: string | null,
  visible?: boolean | null,
  disabled?: boolean | null,
  required?: boolean | null,
  text?: string | null,
  nextStage?: string | null,
  content?: string | null,
  input?: FormLayoutVariantOption | null,
};

export type FormLayoutVariantOption = {
  __typename: "FormLayoutVariantOption",
  current?: Option | null,
  options?:  Array<Option | null > | null,
};

export type FormLayoutReadOnlyField = {
  __typename: "FormLayoutReadOnlyField",
  id: string,
  fieldType?: FormLayoutFieldType | null,
  visible?: boolean | null,
  align?: FormLayoutFieldAlignment | null,
  header?: string | null,
  footer?: string | null,
  footerEmphasized?: boolean | null,
  styles?:  Array<Option | null > | null,
  variesBasedOn?: string | null,
  variants?:  Array<FormLayoutVariant | null > | null,
  resetBasedOnAny?: Array< string > | null,
  text?: string | null,
};

export type FormLayoutInputField = {
  __typename: "FormLayoutInputField",
  id: string,
  fieldType?: FormLayoutFieldType | null,
  visible?: boolean | null,
  align?: FormLayoutFieldAlignment | null,
  header?: string | null,
  footer?: string | null,
  footerEmphasized?: boolean | null,
  styles?:  Array<Option | null > | null,
  variesBasedOn?: string | null,
  variants?:  Array<FormLayoutVariant | null > | null,
  resetBasedOnAny?: Array< string > | null,
  submissionField?: string | null,
  alternateSubmissionField?: string | null,
  disabled?: boolean | null,
  required?: boolean | null,
  inputProperties: FormLayoutInputFieldInput,
};

export type FormLayoutInputFieldInput = {
  __typename: "FormLayoutInputFieldInput",
  current?: Option | null,
};

export type FormLayoutInputFieldInputDate = {
  __typename: "FormLayoutInputFieldInputDate",
  current?: Option | null,
  format?: string | null,
  disabled?: string | null,
  ruleSet?: string | null,
  defaultDate?: string | null,
  // Represents the date to be pre-selected/displayed on the form datepicker by default
  startDate?: string | null,
  // Represents the start date in the range of dates to be enabled on the form datepicker
  endDate?: string | null,
  // Represents the end date in the range of dates to be enabled on the form datepicker
  excludedDates?: Array< string | null > | null,
};

export type FormLayoutInputFieldInputPhone = {
  __typename: "FormLayoutInputFieldInputPhone",
  current?: Option | null,
  mask?: string | null,
  placeholderText?: string | null,
};

export type FormLayoutInputFieldInputTextTypeahead = {
  __typename: "FormLayoutInputFieldInputTextTypeahead",
  current?: Option | null,
  placeholderText?: string | null,
  maxLines?: number | null,
  maxCharacters?: number | null,
  query?: string | null,
};

export type FormLayoutInputFieldInputSelect = {
  __typename: "FormLayoutInputFieldInputSelect",
  current?: Option | null,
  options?:  Array<Option | null > | null,
  interactionType?: FormLayoutInputFieldInputSelectInteraction | null,
  namedSupportingText?: string | null,
  genericSupportingText?: string | null,
  manualEntryRoute?: boolean | null,
  manualEntryStage?: string | null,
  manualOption?: Option | null,
  preSearchText?: string | null,
  filters?:  Array<FormLayoutInputFieldInputSelectFilter | null > | null,
  sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
};

export enum FormLayoutInputFieldInputSelectInteraction {
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
  SEARCH = "SEARCH",
  SEARCH_DIRECTED = "SEARCH_DIRECTED",
}


export type FormLayoutInputFieldInputSelectFilter = {
  __typename: "FormLayoutInputFieldInputSelectFilter",
  label: string,
  subLabel?: string | null,
  keyword: string,
  sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
};

export enum FormLayoutInputFieldInputSelectSortStrategy {
  NOSORT = "NOSORT",
  ALPHANUMERIC = "ALPHANUMERIC",
  ALPHANUMERIC_GROUPED = "ALPHANUMERIC_GROUPED",
}


export type FormLayoutInputFieldInputMultiSelectSearch = {
  __typename: "FormLayoutInputFieldInputMultiSelectSearch",
  // default selected options, comma separated
  current?: Option | null,
  options?:  Array<Option | null > | null,
  // placeholder prompt for the input field when no default, e.g. "Add one or more team member(s)..."
  placeholderText?: string | null,
  // search header, e.g. "Select Team Member(s)"
  searchHeader?: string | null,
  // search placeholder prompt, e.g. "Search team members..."
  searchPlaceholderText?: string | null,
  sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
};

export type FormLayoutInputFieldInputText = {
  __typename: "FormLayoutInputFieldInputText",
  current?: Option | null,
  placeholderText?: string | null,
  minCharacters?: number | null,
  // inclusive; no restriction when null
  maxLines?: number | null,
  maxCharacters?: number | null,
  hideMaxCharactersCount?: boolean | null,
  keyboard?: FormLayoutInputFieldInputTextKeyboard | null,
  minNumericValue?: number | null,
};

export enum FormLayoutInputFieldInputTextKeyboard {
  PERSON_NAME = "PERSON_NAME",
  NUMBER = "NUMBER",
  NUMBER_DECIMAL = "NUMBER_DECIMAL",
  NUMBER_CURRENCY = "NUMBER_CURRENCY",
  NUMBER_DECIMAL_CURRENCY = "NUMBER_DECIMAL_CURRENCY",
  EMAIL = "EMAIL",
  URL = "URL",
  GIFT_CARD = "GIFT_CARD",
  LOYALTY_ID = "LOYALTY_ID",
}


export type FormLayoutInputFieldInputBool = {
  __typename: "FormLayoutInputFieldInputBool",
  current?: Option | null,
};

export type FormLayoutInputFieldInputMultiSelect = {
  __typename: "FormLayoutInputFieldInputMultiSelect",
  // default selected options, comma separated
  current?: Option | null,
  options?:  Array<Option | null > | null,
  // placeholder prompt for the input field when no default, e.g. "Select all that apply"
  placeholderText?: string | null,
};

export type FormLayoutInputFieldInputTime = {
  __typename: "FormLayoutInputFieldInputTime",
  current?: Option | null,
  ruleSet?: string | null,
  format?: string | null,
};

export type FormLayoutTableField = {
  __typename: "FormLayoutTableField",
  id: string,
  fieldType?: FormLayoutFieldType | null,
  visible?: boolean | null,
  align?: FormLayoutFieldAlignment | null,
  header?: string | null,
  footer?: string | null,
  footerEmphasized?: boolean | null,
  styles?:  Array<Option | null > | null,
  variesBasedOn?: string | null,
  variants?:  Array<FormLayoutVariant | null > | null,
  resetBasedOnAny?: Array< string > | null,
  content?: string | null,
};

export enum FormLayoutOrientation {
  VERTICAL = "VERTICAL",
  HORIZONTAL = "HORIZONTAL",
}


export type FormLayoutStageAside = {
  __typename: "FormLayoutStageAside",
  id: string,
  header?: string | null,
  footer?: string | null,
  groups?:  Array<FormLayoutGroup | null > | null,
  styles?:  Array<Option | null > | null,
};

export type SupportSearchResult = {
  __typename: "SupportSearchResult",
  articles?:  Array<Article | null > | null,
  forms?:  Array<SupportCategory | null > | null,
  searchResultCases?:  Array<SupportSearchResultCase | null > | null,
};

export type SupportSearchResultCase = {
  __typename: "SupportSearchResultCase",
  id: string,
  number: string,
  status: CaseStatus,
  description: string,
  longDescription?: string | null,
  commentPreview?: string | null,
  openedOn?: string | null,
  updatedOn: string,
  confidential?: boolean | null,
  locationNum?: string | null,
  contact?: User | null,
};

export type SearchCaseFilters = {
  locationNums?: Array< string | null > | null,
  category?: SearchCaseCategory | null,
};

export enum SearchCaseCategory {
  MY_OPEN = "MY_OPEN",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  ALL = "ALL",
}


export type Appointment = {
  __typename: "Appointment",
  id: string,
  caseNumber?: string | null,
  subject?: string | null,
  description?: string | null,
  contact?: string | null,
  status?: AppointmentStatus | null,
  dueDate?: string | null,
  technician?: User | null,
  restaurant?: Restaurant | null,
};

export enum AppointmentStatus {
  SCHEDULED = "SCHEDULED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  CANCELED = "CANCELED",
  IN_PROGRESS = "IN_PROGRESS",
  TECHNICIAN_TRAVELING = "TECHNICIAN_TRAVELING",
  UNKNOWN = "UNKNOWN",
}


export type ProgramMemberships = {
  __typename: "ProgramMemberships",
  locationMemberships?:  Array<ProgramMembershipRestaurant | null > | null,
  userMemberships?:  Array<ProgramMembershipUser | null > | null,
};

export type ProgramMembershipRestaurant = {
  __typename: "ProgramMembershipRestaurant",
  program: Program,
  locationNum: string,
};

export type ProgramMembership = {
  __typename: "ProgramMembership",
  program?: Program | null,
};

export type ProgramMembershipUser = {
  __typename: "ProgramMembershipUser",
  program: Program,
  guid: string,
};

export type Asset = {
  __typename: "Asset",
  id: string,
  tag?: string | null,
  csiCode?: string | null,
  serial: string,
  name: string,
  locationNum: string,
  type: AssetType,
  model?: AssetModel | null,
  manufacturer?: string | null,
  relatedCases?:  Array<CaseIdentifier | null > | null,
  department?: string | null,
  resources?:  Array<AssetResource | null > | null,
  flowInfo?: TroubleshootingFlowInfo | null,
  // null if no flow available; first flow info if multiple
  flowInfos?:  Array<TroubleshootingFlowInfo > | null,
};

export type AssetType = {
  __typename: "AssetType",
  id: string,
  name: string,
  imageURL?: string | null,
  family?: string | null,
};

export type AssetModel = {
  __typename: "AssetModel",
  id: string,
  imageURL?: string | null,
  allowAdditionalEquipmentRequest: boolean,
};

export type AssetResource = {
  __typename: "AssetResource",
  key: string,
  externalURL: string,
  imageName?: string | null,
  label: string,
};

export type TroubleshootingFlowInfo = {
  __typename: "TroubleshootingFlowInfo",
  flowId: string,
  flowName: string,
  title: string,
  description: string,
  thumbnailImageURL: string,
  minimumAppVersion: string,
};

export type AssetViewed = {
  __typename: "AssetViewed",
  id: string,
  tag?: string | null,
  serial?: string | null,
  locationNum: string,
  viewedOn: string,
};

export type AssetWarranty = {
  __typename: "AssetWarranty",
  id: string,
  // opaque guid from Asset API
  type: AssetWarrantyType,
  name: string,
  status: AssetWarrantyStatus,
  expiresOn?: string | null,
  termMonths?: number | null,
  coverage?: AssetWarrantyCoverage | null,
};

export enum AssetWarrantyType {
  ORIGINAL_PARTS = "ORIGINAL_PARTS",
}


export enum AssetWarrantyStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  UNKNOWN = "UNKNOWN",
}


export type AssetWarrantyCoverage = {
  __typename: "AssetWarrantyCoverage",
  header: string,
  body: string,
};

export type AssetServiceHistory = {
  __typename: "AssetServiceHistory",
  assetId: string,
  locationNum: string,
  events:  Array<AssetServiceEvent | null >,
  totalCostUSD: string,
};

export type AssetServiceEvent = {
  __typename: "AssetServiceEvent",
  id: string,
  // opaque guid from Asset API
  assetId: string,
  locationNum: string,
  status: AssetServiceEventStatus,
  costUSD: string,
  serviceDate: string,
  issue?: string | null,
  resolution?: string | null,
  technicianName?: string | null,
  source?: AssetServiceEventSource | null,
  vendor?: string | null,
  createdOn?: string | null,
  updatedOn?: string | null,
  createdBy?: User | null,
  updatedBy?: User | null,
  attachments?:  Array<AttachmentDownload | null > | null,
};

export enum AssetServiceEventStatus {
  SCHEDULED = "SCHEDULED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}


export enum AssetServiceEventSource {
  CFA_SUPPORT = "CFA_SUPPORT",
  DYNAMICS = "DYNAMICS",
}


export type AttachmentDownload = {
  __typename: "AttachmentDownload",
  id: string,
  fileName: string,
  mimeType: string,
  downloadUrl: string,
  scheme: AttachmentScheme,
};

export type FacilityCategory = {
  __typename: "FacilityCategory",
  type: FacilityCategoryType,
  label: string,
  order: number,
  getSupportURL: string,
  matches?: Array< string | null > | null,
};

export enum FacilityCategoryType {
  DOORS = "DOORS",
  TILES = "TILES",
  SHELVING = "SHELVING",
  PLUMBING = "PLUMBING",
  OTHER = "OTHER",
}


export type LocationAlert = {
  __typename: "LocationAlert",
  locationNum: string,
  assetAlerts:  Array<AssetAlert | null >,
};

export type TroubleshootingFlow = {
  __typename: "TroubleshootingFlow",
  id: string,
  name: string,
  // e.g. PAX D190 Card Reader
  shortName?: string | null,
  // e.g. D190
  startStepId: string,
  steps:  Array<FlowStep | null >,
  summaryMappings?:  Array<FlowSummaryMapping | null > | null,
  defaults:  Array<FlowVariable | null >,
};

export type FlowStep = {
  __typename: "FlowStep",
  id: string,
  instructions:  Array<FlowInstruction | null >,
  mustBranchDynamically: boolean,
  staticBranches:  Array<FlowBranch | null >,
  branchLabelOverride?: string | null,
  isBacktrackDisabled?: boolean | null,
  // if formToSubmit not null, ignore branching
  formToSubmit?: FlowStepForm | null,
  heroImageURL?: string | null,
  defaults?:  Array<FlowVariable | null > | null,
};

export type FlowInstruction = {
  __typename: "FlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type DisplayTextFlowInstruction = {
  __typename: "DisplayTextFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  header?: string | null,
  content?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export enum FlowInstructionType {
  DISPLAY_TEXT = "DISPLAY_TEXT",
  ATTACHMENT_INPUT = "ATTACHMENT_INPUT",
  TEXT_INPUT = "TEXT_INPUT",
  SELECT_SEARCH_INPUT = "SELECT_SEARCH_INPUT",
  SINGLE_SELECT_INPUT = "SINGLE_SELECT_INPUT",
  MULTI_SELECT_INPUT = "MULTI_SELECT_INPUT",
  SUMMARY_DETAILS_INPUT = "SUMMARY_DETAILS_INPUT",
  KB_ARTICLE = "KB_ARTICLE",
  IMAGE = "IMAGE",
  CLOSE_FLOW = "CLOSE_FLOW",
  RESTART_FLOW = "RESTART_FLOW",
  LAUNCH_FORM = "LAUNCH_FORM",
  ICON = "ICON",
  SPACING = "SPACING",
  ASSET_TAG_GRAPHIC = "ASSET_TAG_GRAPHIC",
  EQUIPMENT_INFO = "EQUIPMENT_INFO",
  ASSET_TAG_INPUT = "ASSET_TAG_INPUT",
  LOCATION_PICKER_INPUT = "LOCATION_PICKER_INPUT",
  TICKET_CONTACT_PICKER_INPUT = "TICKET_CONTACT_PICKER_INPUT",
}


export type FlowInstructionVariant = {
  __typename: "FlowInstructionVariant",
  key: string,
  changes: FlowInstructionVariantChanges,
};

export type FlowInstructionVariantChanges = {
  __typename: "FlowInstructionVariantChanges",
  visible?: boolean | null,
  optional?: boolean | null,
  options?:  Array<Option | null > | null,
};

export type SpacingFlowInstruction = {
  __typename: "SpacingFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  spacingType: SpacingInstructionType,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export enum SpacingInstructionType {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}


export type EquipmentInfoFlowInstruction = {
  __typename: "EquipmentInfoFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  equipmentInfoLabel?: string | null,
  modelCategoryName?: string | null,
  modelNumber?: string | null,
  manufacturer?: string | null,
  serial?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type SelectSearchInputFlowInstruction = {
  __typename: "SelectSearchInputFlowInstruction",
  id: string,
  // SELECT_SEARCH_INPUT
  instructionType: FlowInstructionType,
  flowVariableId: string,
  // input field label, e.g. "Serial number"
  label: string,
  showLabelInline: boolean,
  // placeholder prompt for the input field when no default, e.g. "Select"
  placeholderText?: string | null,
  footer?: string | null,
  // options available to show
  options:  Array<Option | null >,
  // other option to show, e.g. "Serial number not shown"
  otherOption?: Option | null,
  // search header, e.g. "Select Serial Number"
  searchHeader?: string | null,
  // search placeholder prompt, e.g. "Search serial number"
  searchPlaceholderText?: string | null,
  filters?:  Array<SelectFilter > | null,
  sortStrategy?: SelectSortStrategy | null,
  optional: boolean,
  visible: boolean,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
  summaryPolicy?: SingleValueSummaryPolicy | null,
};

export type SelectFilter = {
  __typename: "SelectFilter",
  // filter tab label, e.g. "Top"
  label: string,
  // sub-label to shown within the filtered tab, e.g. "Top chosen items"
  subLabel?: string | null,
  // underlying filter value to match against on the Option, e.g. "top"
  keyword: string,
  // sort strategy to utilize when this filter tab is active
  sortStrategy?: SelectSortStrategy | null,
};

export enum SelectSortStrategy {
  NOSORT = "NOSORT",
  ALPHANUMERIC = "ALPHANUMERIC",
  ALPHANUMERIC_GROUPED = "ALPHANUMERIC_GROUPED",
}


export type SingleValueSummaryPolicy = {
  __typename: "SingleValueSummaryPolicy",
  // describes how to map the input value to a captured summary message
  mappings:  Array<FlowSummaryMapping | null >,
};

export type FlowSummaryMapping = {
  __typename: "FlowSummaryMapping",
  // e.g. "did_that_fix_your_issue"
  matchFlowVariableId: string,
  // e.g. "no"
  matchFlowVariableValue: string,
  // e.g. "Reseating the battery did not fix the issue."
  message: string,
};

export type SummaryInputFlowInstruction = {
  __typename: "SummaryInputFlowInstruction",
  id: string,
  // SUMMARY_DETAILS_INPUT
  instructionType: FlowInstructionType,
  flowVariableId: string,
  // e.g. Troubleshooting summary
  label: string,
  detailsInput: SummaryInputFlowDetails,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type SummaryInputFlowDetails = {
  __typename: "SummaryInputFlowDetails",
  // e.g. Additional comments or questions
  label: string,
  minLines: number,
  maxLines: number,
  // e.g. Add details...
  placeholder?: string | null,
  footer?: string | null,
  // default required unless optional=true
  optional: boolean,
};

export type AssetTagGraphicFlowInstruction = {
  __typename: "AssetTagGraphicFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  tagNumber: string,
  state: AssetTagGraphicInstructionState,
  assetTagGraphicLabel?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export enum AssetTagGraphicInstructionState {
  DEFAULT = "DEFAULT",
  HIGHLIGHTED = "HIGHLIGHTED",
}


export type LocationPickerInputFlowInstruction = {
  __typename: "LocationPickerInputFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  flowVariableId: string,
  locationPickerLabel?: string | null,
  footer?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type CloseButtonFlowInstruction = {
  __typename: "CloseButtonFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  text: string,
  style: ButtonInstructionStyle,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export enum ButtonInstructionStyle {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TEXT_ONLY = "TEXT_ONLY",
}


export type ImageFlowInstruction = {
  __typename: "ImageFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  imageURL: string,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type MultiSelectInputFlowInstruction = {
  __typename: "MultiSelectInputFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  label: string,
  flowVariableId: string,
  options:  Array<Option | null >,
  optional: boolean,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
  summaryPolicy?: MultiValueSummaryPolicy | null,
};

export type MultiValueSummaryPolicy = {
  __typename: "MultiValueSummaryPolicy",
  // describes how to format the captured summary message
  // $SUMMARY_VAL$ is a comma-joined string of the mapped summary messages described by mappings
  // e.g. template="Please contact between: $SUMMARY_VAL$."; message="Please contact between 9am to 11am, 2pm to 5pm."
  template: string,
  // describes how to map each input value selected to a corresponding summary message
  mappings:  Array<FlowSummaryMapping | null >,
};

export type RestartButtonFlowInstruction = {
  __typename: "RestartButtonFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  text: string,
  style: ButtonInstructionStyle,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type InputFlowInstruction = {
  __typename: "InputFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  label: string,
  flowVariableId: string,
  optional: boolean,
  keyboard: TextInputInstructionKeyboard,
  minLines: number,
  maxLines: number,
  footer?: string | null,
  placeholder?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
  summaryPolicy?: InputValueSummaryPolicy | null,
};

export enum TextInputInstructionKeyboard {
  DEFAULT = "DEFAULT",
  NUMBER = "NUMBER",
}


export type InputValueSummaryPolicy = {
  __typename: "InputValueSummaryPolicy",
  // describes how to format the captured summary message
  // e.g. template="Model: $SUMMARY_VAL$"; message="Model: PFE-500"
  template: string,
  // fallback value for the $SUMMARY_VAL$ to use in summary message
  // e.g. default="Not entered"; message="Model: Not entered" if empty or null $INPUT_VALUE
  default?: string | null,
};

export type IconFlowInstruction = {
  __typename: "IconFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  symbol: IconSymbol,
  color: IconColor,
  footer?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export enum IconSymbol {
  SUCCESS = "SUCCESS",
  PHONE = "PHONE",
  ACTIVE_WARRANTY = "ACTIVE_WARRANTY",
  EXPIRED_WARRANTY = "EXPIRED_WARRANTY",
  UNKNOWN_WARRANTY = "UNKNOWN_WARRANTY",
  WARNING = "WARNING",
}


export enum IconColor {
  DEFAULT = "DEFAULT",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  ATTENTION = "ATTENTION",
}


export type AttachmentInputFlowInstruction = {
  __typename: "AttachmentInputFlowInstruction",
  id: string,
  // ATTACHMENT_INPUT
  instructionType: FlowInstructionType,
  // e.g. Add a photo of your card reader
  label: string,
  // e.g. Add photos and files
  placeholder?: string | null,
  // e.g. Add up to 5 attachments
  footer?: string | null,
  maxAttachments: number,
  // assume required by default until optional=true
  optional: boolean,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type TicketContactPickerInputFlowInstruction = {
  __typename: "TicketContactPickerInputFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  flowVariableId: string,
  variesByFlowVariableId?: string | null,
  ticketContactPickerLabel?: string | null,
  footer?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type AssetTagInputFlowInstruction = {
  __typename: "AssetTagInputFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  flowVariableId: string,
  assetTagInputTitle?: string | null,
  assetTagInputLabel?: string | null,
  placeholder?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
  summaryPolicy?: InputValueSummaryPolicy | null,
};

export type SingleSelectInputFlowInstruction = {
  __typename: "SingleSelectInputFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  label: string,
  flowVariableId: string,
  options:  Array<Option | null >,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
  summaryPolicy?: SingleValueSummaryPolicy | null,
};

export type KBArticleFlowInstruction = {
  __typename: "KBArticleFlowInstruction",
  id: string,
  instructionType: FlowInstructionType,
  kbNumber: string,
  title: string,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type FormButtonFlowInstruction = {
  __typename: "FormButtonFlowInstruction",
  id: string,
  // LAUNCH_FORM
  instructionType: FlowInstructionType,
  // e.g. Open a Ticket
  text: string,
  // e.g. PRIMARY
  style: ButtonInstructionStyle,
  formId: string,
  formDefaultMappings:  Array<FormFlowMapping | null >,
  // default submission variable for the troubleshooting summary
  formDefaultSummaryId?: string | null,
  variesBasedOn?: string | null,
  variants?:  Array<FlowInstructionVariant > | null,
};

export type FormFlowMapping = {
  __typename: "FormFlowMapping",
  formVariableId: string,
  flowVariableId?: string | null,
  literalValue?: string | null,
};

export type FlowBranch = {
  __typename: "FlowBranch",
  id: string,
  matchConditions:  Array<FlowMatchCondition | null >,
  nextStepId: string,
};

export type FlowMatchCondition = {
  __typename: "FlowMatchCondition",
  flowVariableId: string,
  matchingValue?: string | null,
};

export type FlowStepForm = {
  __typename: "FlowStepForm",
  formId: string,
  formVariableMappings:  Array<FormFlowMapping | null >,
  formSummaryMapping?: FormFlowMapping | null,
  successMessage: string,
  // override for the restart button on the success screen, e.g. "Fix another asset tag"
  restartLabelOverride?: string | null,
};

export type FlowVariable = {
  __typename: "FlowVariable",
  id: string,
  value?: string | null,
};

export type FlowVariableInput = {
  id: string,
  value?: string | null,
};

export type HealthSummary = {
  __typename: "HealthSummary",
  id: string,
  status: HealthStatus,
};

// Health
export enum HealthStatus {
  UP = "UP",
  DEGRADED = "DEGRADED",
  DOWN = "DOWN",
}


export type AddCommentMutationVariables = {
  comment: string,
  caseId: string,
};

export type AddCommentMutation = {
  // Used by client app
  addComment:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  },
};

export type ChangeCaseStatusMutationVariables = {
  status: CaseStatus,
  caseId: string,
  comment?: string | null,
};

export type ChangeCaseStatusMutation = {
  changeCaseStatus:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  },
};

export type ChangeCaseContactMutationVariables = {
  caseId: string,
  contactId: string,
  contactGuid?: string | null,
  previousContactGuid?: string | null,
  locationNum?: string | null,
};

export type ChangeCaseContactMutation = {
  changeCaseContact: string,
};

export type CloseCaseMutationVariables = {
  caseId: string,
  comment?: string | null,
};

export type CloseCaseMutation = {
  closeCase:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  },
};

export type RequestCaseUpdateMutationVariables = {
  caseId: string,
};

export type RequestCaseUpdateMutation = {
  requestCaseUpdate:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  },
};

export type DeleteAttachmentMutationVariables = {
  id: string,
  caseId: string,
};

export type DeleteAttachmentMutation = {
  deleteAttachment?: string | null,
};

export type SubmitKBFeedbackMutationVariables = {
  articleID: string,
  positive: boolean,
  reasonCode?: number | null,
  comment?: string | null,
};

export type SubmitKBFeedbackMutation = {
  submitKBFeedback?: string | null,
};

export type SubmitCasePromptMutationVariables = {
  input: CasePromptInput,
};

export type SubmitCasePromptMutation = {
  submitCasePrompt:  {
    __typename: "SubmitCasePromptResponse",
    success: boolean,
  },
};

export type ChangeNotificationPreferenceMutationVariables = {
  toggleOn: boolean,
  type?: NotificationType | null,
};

export type ChangeNotificationPreferenceMutation = {
  changeNotificationPreference?: boolean | null,
};

export type MarkCaseReadMutationVariables = {
  caseId: string,
};

export type MarkCaseReadMutation = {
  markCaseRead?: string | null,
};

export type MarkRestaurantVisitedMutationVariables = {
  locationNum: string,
  locationName: string,
};

export type MarkRestaurantVisitedMutation = {
  markRestaurantVisited?: string | null,
};

export type SubmitFormToCreateCaseMutationVariables = {
  locationNum: string,
  formId: string,
  formVariables?: Array< FormVariable | null > | null,
};

export type SubmitFormToCreateCaseMutation = {
  submitFormToCreateCase: ( {
      __typename: "MinorCaseType",
      id: string,
      number: string,
      locationNum: string,
    } | {
      __typename: "SubmitFormResponseType",
      id: string,
      number: string,
      confirmationMessages?: Array< string | null > | null,
    } | {
      __typename: "AssetCaseType",
      id: string,
      number: string,
      description: string,
    }
  ),
};

export type ManageCaseSubscriptionMutationVariables = {
  caseId: string,
  subscribe: boolean,
};

export type ManageCaseSubscriptionMutation = {
  manageCaseSubscription: boolean,
};

export type ManageProgramMembershipMutationVariables = {
  program: Program,
  membership: boolean,
  locationNum?: string | null,
  userGuid?: string | null,
};

export type ManageProgramMembershipMutation = {
  manageProgramMembership: boolean,
};

export type DeleteRecentSearchesMutationVariables = {
  userGuid: string,
  contains: Array< string | null >,
};

export type DeleteRecentSearchesMutation = {
  deleteRecentSearches: boolean,
};

export type ChangeAssetAlertStatusMutationVariables = {
  input: AssetAlertStatusChangeInput,
};

export type ChangeAssetAlertStatusMutation = {
  changeAssetAlertStatus?:  {
    __typename: "AssetAlert",
    id: string,
    locationNum: string,
    locationName: string,
    action: AssetAlertAction,
    actor: string,
    createdOn: string,
    summary: string,
    deviceType: string,
    detail?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type MarkAssetViewedMutationVariables = {
  input: AssetViewedInput,
};

export type MarkAssetViewedMutation = {
  markAssetViewed: string,
};

export type MarkAnnouncementsReadMutationVariables = {
  ids: Array< string | null >,
};

export type MarkAnnouncementsReadMutation = {
  markAnnouncementsRead: boolean,
};

export type TrackUserEventMutationVariables = {
  input: UserEventInput,
};

export type TrackUserEventMutation = {
  trackUserEvent:  {
    __typename: "UserEventInfo",
    userGuid: string,
    eventType: string,
    count: number,
  },
};

export type InitiateSupportCallMutationVariables = {
  input: SupportQueueContext,
};

export type InitiateSupportCallMutation = {
  initiateSupportCall: boolean,
};

export type ClearUserEventInfoMutationVariables = {
  eventType: string,
  filter?: UserEventFilter | null,
};

export type ClearUserEventInfoMutation = {
  clearUserEventInfo: boolean,
};

export type CreateServiceEventMutationVariables = {
  input: CreateServiceEventInput,
};

export type CreateServiceEventMutation = {
  createServiceEvent: string,
};

export type CreateAssetServiceEventMutationVariables = {
  input: CreateServiceEventInput,
};

export type CreateAssetServiceEventMutation = {
  createAssetServiceEvent:  {
    __typename: "ServiceEventCreated",
    id: string,
    attachments?:  Array< {
      __typename: "AttachmentUpload",
      fileName: string,
      uploadUrl: string,
      scheme: AttachmentScheme,
    } | null > | null,
  },
};

export type DeleteAssetServiceEventMutationVariables = {
  input: DeleteServiceEventInput,
};

export type DeleteAssetServiceEventMutation = {
  deleteAssetServiceEvent:  {
    __typename: "ServiceEventDeleted",
    id: string,
  },
};

export type DeleteAssetServiceAttachmentsMutationVariables = {
  input: DeleteServiceAttachmentsInput,
};

export type DeleteAssetServiceAttachmentsMutation = {
  deleteAssetServiceAttachments:  {
    __typename: "ServiceAttachmentsDeleted",
    serviceEventId: string,
  },
};

export type UpdateAssetServiceEventMutationVariables = {
  input: UpdateServiceEventInput,
};

export type UpdateAssetServiceEventMutation = {
  updateAssetServiceEvent:  {
    __typename: "ServiceEventUpdated",
    id: string,
    attachments?:  Array< {
      __typename: "AttachmentUpload",
      fileName: string,
      uploadUrl: string,
      scheme: AttachmentScheme,
    } | null > | null,
  },
};

export type SubmitSearchFeedbackMutationVariables = {
  input?: SearchFeedbackInput | null,
};

export type SubmitSearchFeedbackMutation = {
  submitSearchFeedback: boolean,
};

export type NotifyAddCommentMutationVariables = {
  comment: CommentInput,
};

export type NotifyAddCommentMutation = {
  // returns true when success
  // Used by ServiceNow
  notifyAddComment:  {
    __typename: "ActivityStreamEntryWebSockets",
    id: string,
    caseId: string,
    text?: string | null,
    createdBy?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    createdOn: string,
    locationNum: string,
    downloadURL?: string | null,
    fileName?: string | null,
    mimeType?: string | null,
  },
};

export type NotifyAddAttachmentMutationVariables = {
  attachment: AttachmentInput,
};

export type NotifyAddAttachmentMutation = {
  notifyAddAttachment:  {
    __typename: "ActivityStreamEntryWebSockets",
    id: string,
    caseId: string,
    text?: string | null,
    createdBy?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    createdOn: string,
    locationNum: string,
    downloadURL?: string | null,
    fileName?: string | null,
    mimeType?: string | null,
  },
};

export type NotifyCaseUpdateMutationVariables = {
  input: CaseUpdateInput,
};

export type NotifyCaseUpdateMutation = {
  notifyCaseUpdate?:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  } | null,
};

export type NotifyAnnouncementMutationVariables = {
  announcement: AnnouncementInput,
};

export type NotifyAnnouncementMutation = {
  notifyAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    title?: string | null,
    summary?: string | null,
    category: AnnouncementCategory,
    updatedOn: string,
    hasBeenUpdated?: boolean | null,
    url?: string | null,
    outagePageURL?: string | null,
    majorCaseId?: string | null,
    isUnread: boolean,
    isExpired: boolean,
  } | null,
};

export type NotifyCaseReminderMutationVariables = {
  input: CaseReminderInput,
};

export type NotifyCaseReminderMutation = {
  notifyCaseReminder?: string | null,
};

export type NotifyAppointmentActivityMutationVariables = {
  input: AppointmentActivityInput,
};

export type NotifyAppointmentActivityMutation = {
  notifyAppointmentActivity: boolean,
};

export type NotifyAssetAlertCreatedMutationVariables = {
  input: AssetAlertInput,
};

export type NotifyAssetAlertCreatedMutation = {
  notifyAssetAlertCreated?:  {
    __typename: "AssetAlert",
    id: string,
    locationNum: string,
    locationName: string,
    action: AssetAlertAction,
    actor: string,
    createdOn: string,
    summary: string,
    deviceType: string,
    detail?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type NotifyAssetAlertResolvedMutationVariables = {
  id: string,
};

export type NotifyAssetAlertResolvedMutation = {
  notifyAssetAlertResolved?:  {
    __typename: "AssetAlert",
    id: string,
    locationNum: string,
    locationName: string,
    action: AssetAlertAction,
    actor: string,
    createdOn: string,
    summary: string,
    deviceType: string,
    detail?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type ListCasesQueryVariables = {
  locationNum: string,
  contactGuid?: string | null,
  page?: number | null,
};

export type ListCasesQuery = {
  listCases?:  Array< {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  } | null > | null,
};

export type OpenCasesQueryVariables = {
  locationNum: string,
  contactGuid?: string | null,
  page?: number | null,
};

export type OpenCasesQuery = {
  openCases?:  {
    __typename: "PaginatedCases",
    pageInfo?:  {
      __typename: "Page",
      totalItems?: number | null,
      totalPages?: number | null,
      hasNextPage?: boolean | null,
    } | null,
    cases?:  Array< {
      __typename: "Case",
      id: string,
      number: string,
      confidential: boolean,
      status: CaseStatus,
      description: string,
      longDescription: string,
      assignedTo?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      contact?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      commentsAll?: string | null,
      openedOn: string,
      updatedOn: string,
      closedOn?: string | null,
      locationNum?: string | null,
      fieldMutated?: string | null,
      requestedItem?:  {
        __typename: "RITM",
        id?: string | null,
        number: string,
        requestOptions?:  Array< {
          __typename: "Option",
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null > | null,
      } | null,
      submissionDetails?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
      activityStream:  Array<( {
          __typename: "ActivityStreamComment",
          id: string,
          caseId: string,
          text?: string | null,
          createdBy?:  {
            __typename: string,
            id: string,
            firstName: string,
            lastName?: string | null,
            fullName?: string | null,
            guid?: string | null,
            userName?: string | null,
            audience: Audience,
            personId?: string | null,
            photoURL?: string | null,
            photo?: string | null,
            mobilePhone?: string | null,
            email?: string | null,
            title?: string | null,
          } | null,
          createdOn: string,
          locationNum?: string | null,
          translatedText?: string | null,
        } | {
          __typename: "ActivityStreamAttachment",
          id: string,
          caseId: string,
          text?: string | null,
          createdBy?:  {
            __typename: string,
            id: string,
            firstName: string,
            lastName?: string | null,
            fullName?: string | null,
            guid?: string | null,
            userName?: string | null,
            audience: Audience,
            personId?: string | null,
            photoURL?: string | null,
            photo?: string | null,
            mobilePhone?: string | null,
            email?: string | null,
            title?: string | null,
          } | null,
          createdOn: string,
          locationNum?: string | null,
          downloadURL: string,
          fileName: string,
          mimeType: string,
        }
      ) | null > | null,
      canRequestUpdate: boolean,
      willCloseOn?: string | null,
      isUnread?: boolean | null,
      promptTypes?: Array< CasePromptType | null > | null,
    } | null > | null,
  } | null,
};

export type ListClosedCasesQueryVariables = {
  locationNum: string,
  page?: number | null,
};

export type ListClosedCasesQuery = {
  listClosedCases?:  Array< {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  } | null > | null,
};

export type ClosedCasesQueryVariables = {
  locationNum: string,
  page?: number | null,
};

export type ClosedCasesQuery = {
  closedCases?:  {
    __typename: "PaginatedCases",
    pageInfo?:  {
      __typename: "Page",
      totalItems?: number | null,
      totalPages?: number | null,
      hasNextPage?: boolean | null,
    } | null,
    cases?:  Array< {
      __typename: "Case",
      id: string,
      number: string,
      confidential: boolean,
      status: CaseStatus,
      description: string,
      longDescription: string,
      assignedTo?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      contact?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      commentsAll?: string | null,
      openedOn: string,
      updatedOn: string,
      closedOn?: string | null,
      locationNum?: string | null,
      fieldMutated?: string | null,
      requestedItem?:  {
        __typename: "RITM",
        id?: string | null,
        number: string,
        requestOptions?:  Array< {
          __typename: "Option",
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null > | null,
      } | null,
      submissionDetails?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
      activityStream:  Array<( {
          __typename: "ActivityStreamComment",
          id: string,
          caseId: string,
          text?: string | null,
          createdBy?:  {
            __typename: string,
            id: string,
            firstName: string,
            lastName?: string | null,
            fullName?: string | null,
            guid?: string | null,
            userName?: string | null,
            audience: Audience,
            personId?: string | null,
            photoURL?: string | null,
            photo?: string | null,
            mobilePhone?: string | null,
            email?: string | null,
            title?: string | null,
          } | null,
          createdOn: string,
          locationNum?: string | null,
          translatedText?: string | null,
        } | {
          __typename: "ActivityStreamAttachment",
          id: string,
          caseId: string,
          text?: string | null,
          createdBy?:  {
            __typename: string,
            id: string,
            firstName: string,
            lastName?: string | null,
            fullName?: string | null,
            guid?: string | null,
            userName?: string | null,
            audience: Audience,
            personId?: string | null,
            photoURL?: string | null,
            photo?: string | null,
            mobilePhone?: string | null,
            email?: string | null,
            title?: string | null,
          } | null,
          createdOn: string,
          locationNum?: string | null,
          downloadURL: string,
          fileName: string,
          mimeType: string,
        }
      ) | null > | null,
      canRequestUpdate: boolean,
      willCloseOn?: string | null,
      isUnread?: boolean | null,
      promptTypes?: Array< CasePromptType | null > | null,
    } | null > | null,
  } | null,
};

export type CasesQueryVariables = {
  locationNum: string,
  page?: number | null,
};

export type CasesQuery = {
  // returns *all* cases
  cases?:  {
    __typename: "PaginatedCases",
    pageInfo?:  {
      __typename: "Page",
      totalItems?: number | null,
      totalPages?: number | null,
      hasNextPage?: boolean | null,
    } | null,
    cases?:  Array< {
      __typename: "Case",
      id: string,
      number: string,
      confidential: boolean,
      status: CaseStatus,
      description: string,
      longDescription: string,
      assignedTo?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      contact?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      commentsAll?: string | null,
      openedOn: string,
      updatedOn: string,
      closedOn?: string | null,
      locationNum?: string | null,
      fieldMutated?: string | null,
      requestedItem?:  {
        __typename: "RITM",
        id?: string | null,
        number: string,
        requestOptions?:  Array< {
          __typename: "Option",
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null > | null,
      } | null,
      submissionDetails?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
      activityStream:  Array<( {
          __typename: "ActivityStreamComment",
          id: string,
          caseId: string,
          text?: string | null,
          createdBy?:  {
            __typename: string,
            id: string,
            firstName: string,
            lastName?: string | null,
            fullName?: string | null,
            guid?: string | null,
            userName?: string | null,
            audience: Audience,
            personId?: string | null,
            photoURL?: string | null,
            photo?: string | null,
            mobilePhone?: string | null,
            email?: string | null,
            title?: string | null,
          } | null,
          createdOn: string,
          locationNum?: string | null,
          translatedText?: string | null,
        } | {
          __typename: "ActivityStreamAttachment",
          id: string,
          caseId: string,
          text?: string | null,
          createdBy?:  {
            __typename: string,
            id: string,
            firstName: string,
            lastName?: string | null,
            fullName?: string | null,
            guid?: string | null,
            userName?: string | null,
            audience: Audience,
            personId?: string | null,
            photoURL?: string | null,
            photo?: string | null,
            mobilePhone?: string | null,
            email?: string | null,
            title?: string | null,
          } | null,
          createdOn: string,
          locationNum?: string | null,
          downloadURL: string,
          fileName: string,
          mimeType: string,
        }
      ) | null > | null,
      canRequestUpdate: boolean,
      willCloseOn?: string | null,
      isUnread?: boolean | null,
      promptTypes?: Array< CasePromptType | null > | null,
    } | null > | null,
  } | null,
};

export type TicketQueryVariables = {
  id: string,
  markRead?: boolean | null,
};

export type TicketQuery = {
  ticket?:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  } | null,
};

export type CasesRecentQueryVariables = {
  locationNums: Array< string | null >,
};

export type CasesRecentQuery = {
  casesRecent:  {
    __typename: "CasesRecentPayload",
    locationCasesRecent:  Array< {
      __typename: "CasesRecentRestaurant",
      locationNum: string,
      cases?:  Array< {
        __typename: "Case",
        id: string,
        number: string,
        confidential: boolean,
        status: CaseStatus,
        description: string,
        longDescription: string,
        assignedTo?:  {
          __typename: "User",
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        contact?:  {
          __typename: "User",
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        commentsAll?: string | null,
        openedOn: string,
        updatedOn: string,
        closedOn?: string | null,
        locationNum?: string | null,
        fieldMutated?: string | null,
        requestedItem?:  {
          __typename: "RITM",
          id?: string | null,
          number: string,
          requestOptions?:  Array< {
            __typename: "Option",
            label?: string | null,
            supportingLabels?: Array< string | null > | null,
            value?: string | null,
            filterSets?: Array< string | null > | null,
            matches?: Array< string | null > | null,
            hiddenMatches?: Array< string | null > | null,
          } | null > | null,
        } | null,
        submissionDetails?:  Array< {
          __typename: "Option",
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null > | null,
        activityStream:  Array<( {
            __typename: "ActivityStreamComment",
            id: string,
            caseId: string,
            text?: string | null,
            createdBy?:  {
              __typename: string,
              id: string,
              firstName: string,
              lastName?: string | null,
              fullName?: string | null,
              guid?: string | null,
              userName?: string | null,
              audience: Audience,
              personId?: string | null,
              photoURL?: string | null,
              photo?: string | null,
              mobilePhone?: string | null,
              email?: string | null,
              title?: string | null,
            } | null,
            createdOn: string,
            locationNum?: string | null,
            translatedText?: string | null,
          } | {
            __typename: "ActivityStreamAttachment",
            id: string,
            caseId: string,
            text?: string | null,
            createdBy?:  {
              __typename: string,
              id: string,
              firstName: string,
              lastName?: string | null,
              fullName?: string | null,
              guid?: string | null,
              userName?: string | null,
              audience: Audience,
              personId?: string | null,
              photoURL?: string | null,
              photo?: string | null,
              mobilePhone?: string | null,
              email?: string | null,
              title?: string | null,
            } | null,
            createdOn: string,
            locationNum?: string | null,
            downloadURL: string,
            fileName: string,
            mimeType: string,
          }
        ) | null > | null,
        canRequestUpdate: boolean,
        willCloseOn?: string | null,
        isUnread?: boolean | null,
        promptTypes?: Array< CasePromptType | null > | null,
      } > | null,
    } >,
  },
};

export type RelatedCasesQueryVariables = {
  majorCaseId: string,
};

export type RelatedCasesQuery = {
  relatedCases:  Array<( {
      __typename: "MinorCaseType",
      id: string,
      number: string,
      locationNum: string,
    } | {
      __typename: "SubmitFormResponseType",
      id: string,
      number: string,
      confirmationMessages?: Array< string | null > | null,
    } | {
      __typename: "AssetCaseType",
      id: string,
      number: string,
      description: string,
    }
  ) | null >,
};

export type CloseCaseReasonsQueryVariables = {
};

export type CloseCaseReasonsQuery = {
  closeCaseReasons?:  Array< {
    __typename: "Option",
    label?: string | null,
    supportingLabels?: Array< string | null > | null,
    value?: string | null,
    filterSets?: Array< string | null > | null,
    matches?: Array< string | null > | null,
    hiddenMatches?: Array< string | null > | null,
  } | null > | null,
};

export type CasePromptsQueryVariables = {
  caseId: string,
  promptTypes?: Array< CasePromptType | null > | null,
};

export type CasePromptsQuery = {
  casePrompts:  Array<( {
      __typename: "CasePromptItemReceived",
      id: string,
      // unique within the scope of the same case
      promptType: CasePromptType,
      title: string,
      description?: string | null,
    } | {
      __typename: "CasePromptViewAppointment",
      id: string,
      // unique within the scope of the same case
      promptType: CasePromptType,
      // VIEW_APPOINTMENT
      title: string,
      // ex: "View Related Appointment"
      description?: string | null,
      // ex: "March 24 at 4:00PM"
      appointmentId: string,
    } | {
      __typename: "CasePromptPMDispatchTechnician",
      id: string,
      // unique within the scope of the same case
      promptType: CasePromptType,
      title: string,
      description?: string | null,
    } | {
      __typename: "CasePromptDispatchTechnician",
      id: string,
      // unique within the scope of the same case
      promptType: CasePromptType,
      title: string,
      description?: string | null,
    } | {
      __typename: "CasePromptItemReceivedNoInstall",
      id: string,
      // unique within the scope of the same case
      promptType: CasePromptType,
      title: string,
      description?: string | null,
    }
  ) | null > | null,
};

export type SupportCategoriesQueryVariables = {
};

export type SupportCategoriesQuery = {
  supportCategories?:  Array< {
    __typename: "SupportCategory",
    id: string,
    label?: string | null,
    description?: string | null,
    imageName?: string | null,
    url: string,
    form?:  {
      __typename: "SupportCategoryForm",
      id: string,
      minimumAppVersion?: string | null,
      introContents?:  {
        __typename: "SupportCategoryFormIntro",
        header?: string | null,
        body?:  Array< {
          __typename: "SupportCategoryFormIntroRow",
          text?: string | null,
          imageName?: string | null,
        } | null > | null,
      } | null,
      showIntroOnLoad?: boolean | null,
      dynamicLayout?: boolean | null,
      caseCategory?: string | null,
      defaults?:  Array< {
        __typename: "FormEntryVariable",
        id: string,
        value?: string | null,
        displayValue?: string | null,
        description?: string | null,
        sensitive?: boolean | null,
      } | null > | null,
    } | null,
    items?:  Array< {
      __typename: "SupportCategory",
      id: string,
      label?: string | null,
      description?: string | null,
      imageName?: string | null,
      url: string,
      form?:  {
        __typename: "SupportCategoryForm",
        id: string,
        minimumAppVersion?: string | null,
        introContents?:  {
          __typename: "SupportCategoryFormIntro",
          header?: string | null,
          body?:  Array< {
            __typename: "SupportCategoryFormIntroRow",
            text?: string | null,
            imageName?: string | null,
          } | null > | null,
        } | null,
        showIntroOnLoad?: boolean | null,
        dynamicLayout?: boolean | null,
        caseCategory?: string | null,
        defaults?:  Array< {
          __typename: "FormEntryVariable",
          id: string,
          value?: string | null,
          displayValue?: string | null,
          description?: string | null,
          sensitive?: boolean | null,
        } | null > | null,
      } | null,
      items?:  Array< {
        __typename: "SupportCategory",
        id: string,
        label?: string | null,
        description?: string | null,
        imageName?: string | null,
        url: string,
        form?:  {
          __typename: "SupportCategoryForm",
          id: string,
          minimumAppVersion?: string | null,
          introContents?:  {
            __typename: "SupportCategoryFormIntro",
            header?: string | null,
            body?:  Array< {
              __typename: "SupportCategoryFormIntroRow",
              text?: string | null,
              imageName?: string | null,
            } | null > | null,
          } | null,
          showIntroOnLoad?: boolean | null,
          dynamicLayout?: boolean | null,
          caseCategory?: string | null,
          defaults?:  Array< {
            __typename: "FormEntryVariable",
            id: string,
            value?: string | null,
            displayValue?: string | null,
            description?: string | null,
            sensitive?: boolean | null,
          } | null > | null,
        } | null,
        items?:  Array< {
          __typename: "SupportCategory",
          id: string,
          label?: string | null,
          description?: string | null,
          imageName?: string | null,
          url: string,
          form?:  {
            __typename: "SupportCategoryForm",
            id: string,
            minimumAppVersion?: string | null,
            introContents?:  {
              __typename: "SupportCategoryFormIntro",
              header?: string | null,
              body?:  Array< {
                __typename: "SupportCategoryFormIntroRow",
                text?: string | null,
                imageName?: string | null,
              } | null > | null,
            } | null,
            showIntroOnLoad?: boolean | null,
            dynamicLayout?: boolean | null,
            caseCategory?: string | null,
            defaults?:  Array< {
              __typename: "FormEntryVariable",
              id: string,
              value?: string | null,
              displayValue?: string | null,
              description?: string | null,
              sensitive?: boolean | null,
            } | null > | null,
          } | null,
          items?:  Array< {
            __typename: "SupportCategory",
            id: string,
            label?: string | null,
            description?: string | null,
            imageName?: string | null,
            url: string,
            form?:  {
              __typename: "SupportCategoryForm",
              id: string,
              minimumAppVersion?: string | null,
              introContents?:  {
                __typename: "SupportCategoryFormIntro",
                header?: string | null,
                body?:  Array< {
                  __typename: "SupportCategoryFormIntroRow",
                  text?: string | null,
                  imageName?: string | null,
                } | null > | null,
              } | null,
              showIntroOnLoad?: boolean | null,
              dynamicLayout?: boolean | null,
              caseCategory?: string | null,
              defaults?:  Array< {
                __typename: "FormEntryVariable",
                id: string,
                value?: string | null,
                displayValue?: string | null,
                description?: string | null,
                sensitive?: boolean | null,
              } | null > | null,
            } | null,
            items?:  Array< {
              __typename: "SupportCategory",
              id: string,
              label?: string | null,
              description?: string | null,
              imageName?: string | null,
              url: string,
              form?:  {
                __typename: "SupportCategoryForm",
                id: string,
                minimumAppVersion?: string | null,
                introContents?:  {
                  __typename: "SupportCategoryFormIntro",
                  header?: string | null,
                  body?:  Array< {
                    __typename: "SupportCategoryFormIntroRow",
                    text?: string | null,
                    imageName?: string | null,
                  } | null > | null,
                } | null,
                showIntroOnLoad?: boolean | null,
                dynamicLayout?: boolean | null,
                caseCategory?: string | null,
                defaults?:  Array< {
                  __typename: "FormEntryVariable",
                  id: string,
                  value?: string | null,
                  displayValue?: string | null,
                  description?: string | null,
                  sensitive?: boolean | null,
                } | null > | null,
              } | null,
              items?:  Array< {
                __typename: "SupportCategory",
                id: string,
                label?: string | null,
                description?: string | null,
                imageName?: string | null,
                url: string,
                form?:  {
                  __typename: "SupportCategoryForm",
                  id: string,
                  minimumAppVersion?: string | null,
                  introContents?:  {
                    __typename: "SupportCategoryFormIntro",
                    header?: string | null,
                    body?:  Array< {
                      __typename: "SupportCategoryFormIntroRow",
                      text?: string | null,
                      imageName?: string | null,
                    } | null > | null,
                  } | null,
                  showIntroOnLoad?: boolean | null,
                  dynamicLayout?: boolean | null,
                  caseCategory?: string | null,
                  defaults?:  Array< {
                    __typename: "FormEntryVariable",
                    id: string,
                    value?: string | null,
                    displayValue?: string | null,
                    description?: string | null,
                    sensitive?: boolean | null,
                  } | null > | null,
                } | null,
                items?:  Array< {
                  __typename: "SupportCategory",
                  id: string,
                  label?: string | null,
                  description?: string | null,
                  imageName?: string | null,
                  url: string,
                  form?:  {
                    __typename: "SupportCategoryForm",
                    id: string,
                    minimumAppVersion?: string | null,
                    introContents?:  {
                      __typename: "SupportCategoryFormIntro",
                      header?: string | null,
                    } | null,
                    showIntroOnLoad?: boolean | null,
                    dynamicLayout?: boolean | null,
                    caseCategory?: string | null,
                    defaults?:  Array< {
                      __typename: "FormEntryVariable",
                      id: string,
                      value?: string | null,
                      displayValue?: string | null,
                      description?: string | null,
                      sensitive?: boolean | null,
                    } | null > | null,
                  } | null,
                  items?:  Array< {
                    __typename: "SupportCategory",
                    id: string,
                    label?: string | null,
                    description?: string | null,
                    imageName?: string | null,
                    url: string,
                    form?:  {
                      __typename: "SupportCategoryForm",
                      id: string,
                      minimumAppVersion?: string | null,
                      showIntroOnLoad?: boolean | null,
                      dynamicLayout?: boolean | null,
                      caseCategory?: string | null,
                    } | null,
                    items?:  Array< {
                      __typename: "SupportCategory",
                      id: string,
                      label?: string | null,
                      description?: string | null,
                      imageName?: string | null,
                      url: string,
                      featuredOrder?: number | null,
                      recentlyFeaturedOrder?: number | null,
                      commonlyUsedOrder?: number | null,
                      recommendedOrder?: number | null,
                      isFeatured?: boolean | null,
                      labelAccoutrement?: string | null,
                      caseCategory?: string | null,
                    } | null > | null,
                    featuredOrder?: number | null,
                    recentlyFeaturedOrder?: number | null,
                    commonlyUsedOrder?: number | null,
                    recommendedOrder?: number | null,
                    isFeatured?: boolean | null,
                    labelAccoutrement?: string | null,
                    caseCategory?: string | null,
                  } | null > | null,
                  featuredOrder?: number | null,
                  recentlyFeaturedOrder?: number | null,
                  commonlyUsedOrder?: number | null,
                  recommendedOrder?: number | null,
                  isFeatured?: boolean | null,
                  labelAccoutrement?: string | null,
                  caseCategory?: string | null,
                } | null > | null,
                featuredOrder?: number | null,
                recentlyFeaturedOrder?: number | null,
                commonlyUsedOrder?: number | null,
                recommendedOrder?: number | null,
                isFeatured?: boolean | null,
                labelAccoutrement?: string | null,
                caseCategory?: string | null,
              } | null > | null,
              featuredOrder?: number | null,
              recentlyFeaturedOrder?: number | null,
              commonlyUsedOrder?: number | null,
              recommendedOrder?: number | null,
              isFeatured?: boolean | null,
              labelAccoutrement?: string | null,
              caseCategory?: string | null,
            } | null > | null,
            featuredOrder?: number | null,
            recentlyFeaturedOrder?: number | null,
            commonlyUsedOrder?: number | null,
            recommendedOrder?: number | null,
            isFeatured?: boolean | null,
            labelAccoutrement?: string | null,
            caseCategory?: string | null,
          } | null > | null,
          featuredOrder?: number | null,
          recentlyFeaturedOrder?: number | null,
          commonlyUsedOrder?: number | null,
          recommendedOrder?: number | null,
          isFeatured?: boolean | null,
          labelAccoutrement?: string | null,
          caseCategory?: string | null,
        } | null > | null,
        featuredOrder?: number | null,
        recentlyFeaturedOrder?: number | null,
        commonlyUsedOrder?: number | null,
        recommendedOrder?: number | null,
        isFeatured?: boolean | null,
        labelAccoutrement?: string | null,
        caseCategory?: string | null,
      } | null > | null,
      featuredOrder?: number | null,
      recentlyFeaturedOrder?: number | null,
      commonlyUsedOrder?: number | null,
      recommendedOrder?: number | null,
      isFeatured?: boolean | null,
      labelAccoutrement?: string | null,
      caseCategory?: string | null,
    } | null > | null,
    featuredOrder?: number | null,
    recentlyFeaturedOrder?: number | null,
    commonlyUsedOrder?: number | null,
    recommendedOrder?: number | null,
    isFeatured?: boolean | null,
    labelAccoutrement?: string | null,
    caseCategory?: string | null,
  } | null > | null,
};

export type SupportCategoriesAssetQueryVariables = {
  context?: SupportCategoryContext | null,
};

export type SupportCategoriesAssetQuery = {
  supportCategoriesAsset?:  Array< {
    __typename: "SupportCategory",
    id: string,
    label?: string | null,
    description?: string | null,
    imageName?: string | null,
    url: string,
    form?:  {
      __typename: "SupportCategoryForm",
      id: string,
      minimumAppVersion?: string | null,
      introContents?:  {
        __typename: "SupportCategoryFormIntro",
        header?: string | null,
        body?:  Array< {
          __typename: "SupportCategoryFormIntroRow",
          text?: string | null,
          imageName?: string | null,
        } | null > | null,
      } | null,
      showIntroOnLoad?: boolean | null,
      dynamicLayout?: boolean | null,
      caseCategory?: string | null,
      defaults?:  Array< {
        __typename: "FormEntryVariable",
        id: string,
        value?: string | null,
        displayValue?: string | null,
        description?: string | null,
        sensitive?: boolean | null,
      } | null > | null,
    } | null,
    items?:  Array< {
      __typename: "SupportCategory",
      id: string,
      label?: string | null,
      description?: string | null,
      imageName?: string | null,
      url: string,
      form?:  {
        __typename: "SupportCategoryForm",
        id: string,
        minimumAppVersion?: string | null,
        introContents?:  {
          __typename: "SupportCategoryFormIntro",
          header?: string | null,
          body?:  Array< {
            __typename: "SupportCategoryFormIntroRow",
            text?: string | null,
            imageName?: string | null,
          } | null > | null,
        } | null,
        showIntroOnLoad?: boolean | null,
        dynamicLayout?: boolean | null,
        caseCategory?: string | null,
        defaults?:  Array< {
          __typename: "FormEntryVariable",
          id: string,
          value?: string | null,
          displayValue?: string | null,
          description?: string | null,
          sensitive?: boolean | null,
        } | null > | null,
      } | null,
      items?:  Array< {
        __typename: "SupportCategory",
        id: string,
        label?: string | null,
        description?: string | null,
        imageName?: string | null,
        url: string,
        form?:  {
          __typename: "SupportCategoryForm",
          id: string,
          minimumAppVersion?: string | null,
          introContents?:  {
            __typename: "SupportCategoryFormIntro",
            header?: string | null,
            body?:  Array< {
              __typename: "SupportCategoryFormIntroRow",
              text?: string | null,
              imageName?: string | null,
            } | null > | null,
          } | null,
          showIntroOnLoad?: boolean | null,
          dynamicLayout?: boolean | null,
          caseCategory?: string | null,
          defaults?:  Array< {
            __typename: "FormEntryVariable",
            id: string,
            value?: string | null,
            displayValue?: string | null,
            description?: string | null,
            sensitive?: boolean | null,
          } | null > | null,
        } | null,
        items?:  Array< {
          __typename: "SupportCategory",
          id: string,
          label?: string | null,
          description?: string | null,
          imageName?: string | null,
          url: string,
          form?:  {
            __typename: "SupportCategoryForm",
            id: string,
            minimumAppVersion?: string | null,
            introContents?:  {
              __typename: "SupportCategoryFormIntro",
              header?: string | null,
              body?:  Array< {
                __typename: "SupportCategoryFormIntroRow",
                text?: string | null,
                imageName?: string | null,
              } | null > | null,
            } | null,
            showIntroOnLoad?: boolean | null,
            dynamicLayout?: boolean | null,
            caseCategory?: string | null,
            defaults?:  Array< {
              __typename: "FormEntryVariable",
              id: string,
              value?: string | null,
              displayValue?: string | null,
              description?: string | null,
              sensitive?: boolean | null,
            } | null > | null,
          } | null,
          items?:  Array< {
            __typename: "SupportCategory",
            id: string,
            label?: string | null,
            description?: string | null,
            imageName?: string | null,
            url: string,
            form?:  {
              __typename: "SupportCategoryForm",
              id: string,
              minimumAppVersion?: string | null,
              introContents?:  {
                __typename: "SupportCategoryFormIntro",
                header?: string | null,
                body?:  Array< {
                  __typename: "SupportCategoryFormIntroRow",
                  text?: string | null,
                  imageName?: string | null,
                } | null > | null,
              } | null,
              showIntroOnLoad?: boolean | null,
              dynamicLayout?: boolean | null,
              caseCategory?: string | null,
              defaults?:  Array< {
                __typename: "FormEntryVariable",
                id: string,
                value?: string | null,
                displayValue?: string | null,
                description?: string | null,
                sensitive?: boolean | null,
              } | null > | null,
            } | null,
            items?:  Array< {
              __typename: "SupportCategory",
              id: string,
              label?: string | null,
              description?: string | null,
              imageName?: string | null,
              url: string,
              form?:  {
                __typename: "SupportCategoryForm",
                id: string,
                minimumAppVersion?: string | null,
                introContents?:  {
                  __typename: "SupportCategoryFormIntro",
                  header?: string | null,
                  body?:  Array< {
                    __typename: "SupportCategoryFormIntroRow",
                    text?: string | null,
                    imageName?: string | null,
                  } | null > | null,
                } | null,
                showIntroOnLoad?: boolean | null,
                dynamicLayout?: boolean | null,
                caseCategory?: string | null,
                defaults?:  Array< {
                  __typename: "FormEntryVariable",
                  id: string,
                  value?: string | null,
                  displayValue?: string | null,
                  description?: string | null,
                  sensitive?: boolean | null,
                } | null > | null,
              } | null,
              items?:  Array< {
                __typename: "SupportCategory",
                id: string,
                label?: string | null,
                description?: string | null,
                imageName?: string | null,
                url: string,
                form?:  {
                  __typename: "SupportCategoryForm",
                  id: string,
                  minimumAppVersion?: string | null,
                  introContents?:  {
                    __typename: "SupportCategoryFormIntro",
                    header?: string | null,
                    body?:  Array< {
                      __typename: "SupportCategoryFormIntroRow",
                      text?: string | null,
                      imageName?: string | null,
                    } | null > | null,
                  } | null,
                  showIntroOnLoad?: boolean | null,
                  dynamicLayout?: boolean | null,
                  caseCategory?: string | null,
                  defaults?:  Array< {
                    __typename: "FormEntryVariable",
                    id: string,
                    value?: string | null,
                    displayValue?: string | null,
                    description?: string | null,
                    sensitive?: boolean | null,
                  } | null > | null,
                } | null,
                items?:  Array< {
                  __typename: "SupportCategory",
                  id: string,
                  label?: string | null,
                  description?: string | null,
                  imageName?: string | null,
                  url: string,
                  form?:  {
                    __typename: "SupportCategoryForm",
                    id: string,
                    minimumAppVersion?: string | null,
                    introContents?:  {
                      __typename: "SupportCategoryFormIntro",
                      header?: string | null,
                    } | null,
                    showIntroOnLoad?: boolean | null,
                    dynamicLayout?: boolean | null,
                    caseCategory?: string | null,
                    defaults?:  Array< {
                      __typename: "FormEntryVariable",
                      id: string,
                      value?: string | null,
                      displayValue?: string | null,
                      description?: string | null,
                      sensitive?: boolean | null,
                    } | null > | null,
                  } | null,
                  items?:  Array< {
                    __typename: "SupportCategory",
                    id: string,
                    label?: string | null,
                    description?: string | null,
                    imageName?: string | null,
                    url: string,
                    form?:  {
                      __typename: "SupportCategoryForm",
                      id: string,
                      minimumAppVersion?: string | null,
                      showIntroOnLoad?: boolean | null,
                      dynamicLayout?: boolean | null,
                      caseCategory?: string | null,
                    } | null,
                    items?:  Array< {
                      __typename: "SupportCategory",
                      id: string,
                      label?: string | null,
                      description?: string | null,
                      imageName?: string | null,
                      url: string,
                      featuredOrder?: number | null,
                      recentlyFeaturedOrder?: number | null,
                      commonlyUsedOrder?: number | null,
                      recommendedOrder?: number | null,
                      isFeatured?: boolean | null,
                      labelAccoutrement?: string | null,
                      caseCategory?: string | null,
                    } | null > | null,
                    featuredOrder?: number | null,
                    recentlyFeaturedOrder?: number | null,
                    commonlyUsedOrder?: number | null,
                    recommendedOrder?: number | null,
                    isFeatured?: boolean | null,
                    labelAccoutrement?: string | null,
                    caseCategory?: string | null,
                  } | null > | null,
                  featuredOrder?: number | null,
                  recentlyFeaturedOrder?: number | null,
                  commonlyUsedOrder?: number | null,
                  recommendedOrder?: number | null,
                  isFeatured?: boolean | null,
                  labelAccoutrement?: string | null,
                  caseCategory?: string | null,
                } | null > | null,
                featuredOrder?: number | null,
                recentlyFeaturedOrder?: number | null,
                commonlyUsedOrder?: number | null,
                recommendedOrder?: number | null,
                isFeatured?: boolean | null,
                labelAccoutrement?: string | null,
                caseCategory?: string | null,
              } | null > | null,
              featuredOrder?: number | null,
              recentlyFeaturedOrder?: number | null,
              commonlyUsedOrder?: number | null,
              recommendedOrder?: number | null,
              isFeatured?: boolean | null,
              labelAccoutrement?: string | null,
              caseCategory?: string | null,
            } | null > | null,
            featuredOrder?: number | null,
            recentlyFeaturedOrder?: number | null,
            commonlyUsedOrder?: number | null,
            recommendedOrder?: number | null,
            isFeatured?: boolean | null,
            labelAccoutrement?: string | null,
            caseCategory?: string | null,
          } | null > | null,
          featuredOrder?: number | null,
          recentlyFeaturedOrder?: number | null,
          commonlyUsedOrder?: number | null,
          recommendedOrder?: number | null,
          isFeatured?: boolean | null,
          labelAccoutrement?: string | null,
          caseCategory?: string | null,
        } | null > | null,
        featuredOrder?: number | null,
        recentlyFeaturedOrder?: number | null,
        commonlyUsedOrder?: number | null,
        recommendedOrder?: number | null,
        isFeatured?: boolean | null,
        labelAccoutrement?: string | null,
        caseCategory?: string | null,
      } | null > | null,
      featuredOrder?: number | null,
      recentlyFeaturedOrder?: number | null,
      commonlyUsedOrder?: number | null,
      recommendedOrder?: number | null,
      isFeatured?: boolean | null,
      labelAccoutrement?: string | null,
      caseCategory?: string | null,
    } | null > | null,
    featuredOrder?: number | null,
    recentlyFeaturedOrder?: number | null,
    commonlyUsedOrder?: number | null,
    recommendedOrder?: number | null,
    isFeatured?: boolean | null,
    labelAccoutrement?: string | null,
    caseCategory?: string | null,
  } | null > | null,
};

export type SupportCategoryItemQueryVariables = {
  id: string,
};

export type SupportCategoryItemQuery = {
  supportCategoryItem?:  {
    __typename: "SupportCategory",
    id: string,
    label?: string | null,
    description?: string | null,
    imageName?: string | null,
    url: string,
    form?:  {
      __typename: "SupportCategoryForm",
      id: string,
      minimumAppVersion?: string | null,
      introContents?:  {
        __typename: "SupportCategoryFormIntro",
        header?: string | null,
        body?:  Array< {
          __typename: "SupportCategoryFormIntroRow",
          text?: string | null,
          imageName?: string | null,
        } | null > | null,
      } | null,
      showIntroOnLoad?: boolean | null,
      dynamicLayout?: boolean | null,
      caseCategory?: string | null,
      defaults?:  Array< {
        __typename: "FormEntryVariable",
        id: string,
        value?: string | null,
        displayValue?: string | null,
        description?: string | null,
        sensitive?: boolean | null,
      } | null > | null,
    } | null,
    items?:  Array< {
      __typename: "SupportCategory",
      id: string,
      label?: string | null,
      description?: string | null,
      imageName?: string | null,
      url: string,
      form?:  {
        __typename: "SupportCategoryForm",
        id: string,
        minimumAppVersion?: string | null,
        introContents?:  {
          __typename: "SupportCategoryFormIntro",
          header?: string | null,
          body?:  Array< {
            __typename: "SupportCategoryFormIntroRow",
            text?: string | null,
            imageName?: string | null,
          } | null > | null,
        } | null,
        showIntroOnLoad?: boolean | null,
        dynamicLayout?: boolean | null,
        caseCategory?: string | null,
        defaults?:  Array< {
          __typename: "FormEntryVariable",
          id: string,
          value?: string | null,
          displayValue?: string | null,
          description?: string | null,
          sensitive?: boolean | null,
        } | null > | null,
      } | null,
      items?:  Array< {
        __typename: "SupportCategory",
        id: string,
        label?: string | null,
        description?: string | null,
        imageName?: string | null,
        url: string,
        form?:  {
          __typename: "SupportCategoryForm",
          id: string,
          minimumAppVersion?: string | null,
          introContents?:  {
            __typename: "SupportCategoryFormIntro",
            header?: string | null,
            body?:  Array< {
              __typename: "SupportCategoryFormIntroRow",
              text?: string | null,
              imageName?: string | null,
            } | null > | null,
          } | null,
          showIntroOnLoad?: boolean | null,
          dynamicLayout?: boolean | null,
          caseCategory?: string | null,
          defaults?:  Array< {
            __typename: "FormEntryVariable",
            id: string,
            value?: string | null,
            displayValue?: string | null,
            description?: string | null,
            sensitive?: boolean | null,
          } | null > | null,
        } | null,
        items?:  Array< {
          __typename: "SupportCategory",
          id: string,
          label?: string | null,
          description?: string | null,
          imageName?: string | null,
          url: string,
          form?:  {
            __typename: "SupportCategoryForm",
            id: string,
            minimumAppVersion?: string | null,
            introContents?:  {
              __typename: "SupportCategoryFormIntro",
              header?: string | null,
              body?:  Array< {
                __typename: "SupportCategoryFormIntroRow",
                text?: string | null,
                imageName?: string | null,
              } | null > | null,
            } | null,
            showIntroOnLoad?: boolean | null,
            dynamicLayout?: boolean | null,
            caseCategory?: string | null,
            defaults?:  Array< {
              __typename: "FormEntryVariable",
              id: string,
              value?: string | null,
              displayValue?: string | null,
              description?: string | null,
              sensitive?: boolean | null,
            } | null > | null,
          } | null,
          items?:  Array< {
            __typename: "SupportCategory",
            id: string,
            label?: string | null,
            description?: string | null,
            imageName?: string | null,
            url: string,
            form?:  {
              __typename: "SupportCategoryForm",
              id: string,
              minimumAppVersion?: string | null,
              introContents?:  {
                __typename: "SupportCategoryFormIntro",
                header?: string | null,
                body?:  Array< {
                  __typename: "SupportCategoryFormIntroRow",
                  text?: string | null,
                  imageName?: string | null,
                } | null > | null,
              } | null,
              showIntroOnLoad?: boolean | null,
              dynamicLayout?: boolean | null,
              caseCategory?: string | null,
              defaults?:  Array< {
                __typename: "FormEntryVariable",
                id: string,
                value?: string | null,
                displayValue?: string | null,
                description?: string | null,
                sensitive?: boolean | null,
              } | null > | null,
            } | null,
            items?:  Array< {
              __typename: "SupportCategory",
              id: string,
              label?: string | null,
              description?: string | null,
              imageName?: string | null,
              url: string,
              form?:  {
                __typename: "SupportCategoryForm",
                id: string,
                minimumAppVersion?: string | null,
                introContents?:  {
                  __typename: "SupportCategoryFormIntro",
                  header?: string | null,
                  body?:  Array< {
                    __typename: "SupportCategoryFormIntroRow",
                    text?: string | null,
                    imageName?: string | null,
                  } | null > | null,
                } | null,
                showIntroOnLoad?: boolean | null,
                dynamicLayout?: boolean | null,
                caseCategory?: string | null,
                defaults?:  Array< {
                  __typename: "FormEntryVariable",
                  id: string,
                  value?: string | null,
                  displayValue?: string | null,
                  description?: string | null,
                  sensitive?: boolean | null,
                } | null > | null,
              } | null,
              items?:  Array< {
                __typename: "SupportCategory",
                id: string,
                label?: string | null,
                description?: string | null,
                imageName?: string | null,
                url: string,
                form?:  {
                  __typename: "SupportCategoryForm",
                  id: string,
                  minimumAppVersion?: string | null,
                  introContents?:  {
                    __typename: "SupportCategoryFormIntro",
                    header?: string | null,
                    body?:  Array< {
                      __typename: "SupportCategoryFormIntroRow",
                      text?: string | null,
                      imageName?: string | null,
                    } | null > | null,
                  } | null,
                  showIntroOnLoad?: boolean | null,
                  dynamicLayout?: boolean | null,
                  caseCategory?: string | null,
                  defaults?:  Array< {
                    __typename: "FormEntryVariable",
                    id: string,
                    value?: string | null,
                    displayValue?: string | null,
                    description?: string | null,
                    sensitive?: boolean | null,
                  } | null > | null,
                } | null,
                items?:  Array< {
                  __typename: "SupportCategory",
                  id: string,
                  label?: string | null,
                  description?: string | null,
                  imageName?: string | null,
                  url: string,
                  form?:  {
                    __typename: "SupportCategoryForm",
                    id: string,
                    minimumAppVersion?: string | null,
                    introContents?:  {
                      __typename: "SupportCategoryFormIntro",
                      header?: string | null,
                    } | null,
                    showIntroOnLoad?: boolean | null,
                    dynamicLayout?: boolean | null,
                    caseCategory?: string | null,
                    defaults?:  Array< {
                      __typename: "FormEntryVariable",
                      id: string,
                      value?: string | null,
                      displayValue?: string | null,
                      description?: string | null,
                      sensitive?: boolean | null,
                    } | null > | null,
                  } | null,
                  items?:  Array< {
                    __typename: "SupportCategory",
                    id: string,
                    label?: string | null,
                    description?: string | null,
                    imageName?: string | null,
                    url: string,
                    form?:  {
                      __typename: "SupportCategoryForm",
                      id: string,
                      minimumAppVersion?: string | null,
                      showIntroOnLoad?: boolean | null,
                      dynamicLayout?: boolean | null,
                      caseCategory?: string | null,
                    } | null,
                    items?:  Array< {
                      __typename: "SupportCategory",
                      id: string,
                      label?: string | null,
                      description?: string | null,
                      imageName?: string | null,
                      url: string,
                      featuredOrder?: number | null,
                      recentlyFeaturedOrder?: number | null,
                      commonlyUsedOrder?: number | null,
                      recommendedOrder?: number | null,
                      isFeatured?: boolean | null,
                      labelAccoutrement?: string | null,
                      caseCategory?: string | null,
                    } | null > | null,
                    featuredOrder?: number | null,
                    recentlyFeaturedOrder?: number | null,
                    commonlyUsedOrder?: number | null,
                    recommendedOrder?: number | null,
                    isFeatured?: boolean | null,
                    labelAccoutrement?: string | null,
                    caseCategory?: string | null,
                  } | null > | null,
                  featuredOrder?: number | null,
                  recentlyFeaturedOrder?: number | null,
                  commonlyUsedOrder?: number | null,
                  recommendedOrder?: number | null,
                  isFeatured?: boolean | null,
                  labelAccoutrement?: string | null,
                  caseCategory?: string | null,
                } | null > | null,
                featuredOrder?: number | null,
                recentlyFeaturedOrder?: number | null,
                commonlyUsedOrder?: number | null,
                recommendedOrder?: number | null,
                isFeatured?: boolean | null,
                labelAccoutrement?: string | null,
                caseCategory?: string | null,
              } | null > | null,
              featuredOrder?: number | null,
              recentlyFeaturedOrder?: number | null,
              commonlyUsedOrder?: number | null,
              recommendedOrder?: number | null,
              isFeatured?: boolean | null,
              labelAccoutrement?: string | null,
              caseCategory?: string | null,
            } | null > | null,
            featuredOrder?: number | null,
            recentlyFeaturedOrder?: number | null,
            commonlyUsedOrder?: number | null,
            recommendedOrder?: number | null,
            isFeatured?: boolean | null,
            labelAccoutrement?: string | null,
            caseCategory?: string | null,
          } | null > | null,
          featuredOrder?: number | null,
          recentlyFeaturedOrder?: number | null,
          commonlyUsedOrder?: number | null,
          recommendedOrder?: number | null,
          isFeatured?: boolean | null,
          labelAccoutrement?: string | null,
          caseCategory?: string | null,
        } | null > | null,
        featuredOrder?: number | null,
        recentlyFeaturedOrder?: number | null,
        commonlyUsedOrder?: number | null,
        recommendedOrder?: number | null,
        isFeatured?: boolean | null,
        labelAccoutrement?: string | null,
        caseCategory?: string | null,
      } | null > | null,
      featuredOrder?: number | null,
      recentlyFeaturedOrder?: number | null,
      commonlyUsedOrder?: number | null,
      recommendedOrder?: number | null,
      isFeatured?: boolean | null,
      labelAccoutrement?: string | null,
      caseCategory?: string | null,
    } | null > | null,
    featuredOrder?: number | null,
    recentlyFeaturedOrder?: number | null,
    commonlyUsedOrder?: number | null,
    recommendedOrder?: number | null,
    isFeatured?: boolean | null,
    labelAccoutrement?: string | null,
    caseCategory?: string | null,
  } | null,
};

export type SupportContextQueryVariables = {
  caseNumber: string,
};

export type SupportContextQuery = {
  supportContext?:  {
    __typename: "SupportContext",
    supportDeskPhoneNumber?: string | null,
    queue?:  {
      __typename: "SupportQueue",
      isOpen: boolean,
      personsInQueueCount?: number | null,
      routingKey?: string | null,
    } | null,
    assignedTo?: string | null,
  } | null,
};

export type AnnouncementsQueryVariables = {
};

export type AnnouncementsQuery = {
  announcements?:  Array< {
    __typename: "Announcement",
    id: string,
    title?: string | null,
    summary?: string | null,
    category: AnnouncementCategory,
    updatedOn: string,
    hasBeenUpdated?: boolean | null,
    url?: string | null,
    outagePageURL?: string | null,
    majorCaseId?: string | null,
    isUnread: boolean,
    isExpired: boolean,
  } | null > | null,
};

export type RequestQueryVariables = {
  caseNumber: string,
  requestedItemNumber?: string | null,
};

export type RequestQuery = {
  request?:  {
    __typename: "CaseSubmissionRequest",
    number?: string | null,
    details?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type SecureServiceNowLinkQueryVariables = {
  unsecureLink: string,
};

export type SecureServiceNowLinkQuery = {
  secureServiceNowLink?: string | null,
};

export type KbFeedbackReasonsQueryVariables = {
};

export type KbFeedbackReasonsQuery = {
  kbFeedbackReasons?:  Array< {
    __typename: "Option",
    label?: string | null,
    supportingLabels?: Array< string | null > | null,
    value?: string | null,
    filterSets?: Array< string | null > | null,
    matches?: Array< string | null > | null,
    hiddenMatches?: Array< string | null > | null,
  } | null > | null,
};

export type KbArticleQueryVariables = {
  id: string,
  trackView?: boolean | null,
  foundViaQueryId?: string | null,
  foundViaResultId?: string | null,
};

export type KbArticleQuery = {
  kbArticle?:  {
    __typename: "Article",
    id: string,
    number: string,
    title: string,
    solutionContent?: string | null,
    visibility?: ArticleVisibility | null,
    preview?: string | null,
    searchQueryId?: string | null,
    searchResultId?: string | null,
  } | null,
};

export type KbArticlesRecentQueryVariables = {
};

export type KbArticlesRecentQuery = {
  kbArticlesRecent?:  Array< {
    __typename: "Article",
    id: string,
    number: string,
    title: string,
    solutionContent?: string | null,
    visibility?: ArticleVisibility | null,
    preview?: string | null,
    searchQueryId?: string | null,
    searchResultId?: string | null,
  } | null > | null,
};

export type KbArticlesFeaturedQueryVariables = {
};

export type KbArticlesFeaturedQuery = {
  kbArticlesFeatured?:  Array< {
    __typename: "Article",
    id: string,
    number: string,
    title: string,
    solutionContent?: string | null,
    visibility?: ArticleVisibility | null,
    preview?: string | null,
    searchQueryId?: string | null,
    searchResultId?: string | null,
  } | null > | null,
};

export type KbArticlesAnswersQueryVariables = {
};

export type KbArticlesAnswersQuery = {
  kbArticlesAnswers?:  {
    __typename: "KBAnswers",
    articlesFeatured?:  Array< {
      __typename: "Article",
      id: string,
      number: string,
      title: string,
      solutionContent?: string | null,
      visibility?: ArticleVisibility | null,
      preview?: string | null,
      searchQueryId?: string | null,
      searchResultId?: string | null,
    } | null > | null,
    articlesRecent?:  Array< {
      __typename: "Article",
      id: string,
      number: string,
      title: string,
      solutionContent?: string | null,
      visibility?: ArticleVisibility | null,
      preview?: string | null,
      searchQueryId?: string | null,
      searchResultId?: string | null,
    } | null > | null,
  } | null,
};

export type AirshipUserPropertiesQueryVariables = {
  namedUserGuid?: string | null,
};

export type AirshipUserPropertiesQuery = {
  airshipUserProperties?:  {
    __typename: "AirshipUserProperties",
    tagGroups?:  Array< {
      __typename: "AirshipTagGroup",
      name: string,
      tags: Array< string | null >,
    } | null > | null,
    attributes?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type UserInfoQueryVariables = {
};

export type UserInfoQuery = {
  userInfo:  {
    __typename: "UserInfo",
    user:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    },
    countryCode?: string | null,
  },
};

export type UserEventInfoQueryVariables = {
  eventType: string,
  filter?: UserEventFilter | null,
};

export type UserEventInfoQuery = {
  userEventInfo:  {
    __typename: "UserEventInfo",
    userGuid: string,
    eventType: string,
    count: number,
  },
};

export type RestaurantQueryVariables = {
  locationNum: string,
};

export type RestaurantQuery = {
  // Clients: be very careful to only request the Restaurant properties you absolutely need for your limited interface context
  restaurant?:  {
    __typename: "Restaurant",
    id?: string | null,
    number: string,
    name?: string | null,
    contacts?:  Array< {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null > | null,
    siteProperties?:  {
      __typename: "RestaurantSite",
      lat?: number | null,
      long?: number | null,
      countryCode?: string | null,
      utcOffset?: string | null,
      tzId?: string | null,
    } | null,
    openCasesCount?: number | null,
    operator?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    supportDeskPhoneNumber?: string | null,
  } | null,
};

export type RestaurantsQueryVariables = {
  contains?: string | null,
};

export type RestaurantsQuery = {
  restaurants?:  Array< {
    __typename: "Restaurant",
    id?: string | null,
    number: string,
    name?: string | null,
    contacts?:  Array< {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null > | null,
    siteProperties?:  {
      __typename: "RestaurantSite",
      lat?: number | null,
      long?: number | null,
      countryCode?: string | null,
      utcOffset?: string | null,
      tzId?: string | null,
    } | null,
    openCasesCount?: number | null,
    operator?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    supportDeskPhoneNumber?: string | null,
  } | null > | null,
};

export type RestaurantsRecentQueryVariables = {
  userGuid: string,
};

export type RestaurantsRecentQuery = {
  restaurantsRecent?:  Array< {
    __typename: "Restaurant",
    id?: string | null,
    number: string,
    name?: string | null,
    contacts?:  Array< {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null > | null,
    siteProperties?:  {
      __typename: "RestaurantSite",
      lat?: number | null,
      long?: number | null,
      countryCode?: string | null,
      utcOffset?: string | null,
      tzId?: string | null,
    } | null,
    openCasesCount?: number | null,
    operator?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    supportDeskPhoneNumber?: string | null,
  } | null > | null,
};

export type RestaurantsAssignedQueryVariables = {
  consultantGuid: string,
};

export type RestaurantsAssignedQuery = {
  restaurantsAssigned?:  Array< {
    __typename: "Restaurant",
    id?: string | null,
    number: string,
    name?: string | null,
    contacts?:  Array< {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null > | null,
    siteProperties?:  {
      __typename: "RestaurantSite",
      lat?: number | null,
      long?: number | null,
      countryCode?: string | null,
      utcOffset?: string | null,
      tzId?: string | null,
    } | null,
    openCasesCount?: number | null,
    operator?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    supportDeskPhoneNumber?: string | null,
  } | null > | null,
};

export type RestaurantsStaffQueryVariables = {
  userGuid: string,
};

export type RestaurantsStaffQuery = {
  restaurantsStaff?:  {
    __typename: "StaffRestaurants",
    type: StaffRestaurantsType,
    restaurants:  Array< {
      __typename: "Restaurant",
      id?: string | null,
      number: string,
      name?: string | null,
      contacts?:  Array< {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null > | null,
      siteProperties?:  {
        __typename: "RestaurantSite",
        lat?: number | null,
        long?: number | null,
        countryCode?: string | null,
        utcOffset?: string | null,
        tzId?: string | null,
      } | null,
      openCasesCount?: number | null,
      operator?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      supportDeskPhoneNumber?: string | null,
    } | null >,
  } | null,
};

export type SupportAppConfigQueryVariables = {
};

export type SupportAppConfigQuery = {
  supportAppConfig?:  Array< {
    __typename: "Option",
    label?: string | null,
    supportingLabels?: Array< string | null > | null,
    value?: string | null,
    filterSets?: Array< string | null > | null,
    matches?: Array< string | null > | null,
    hiddenMatches?: Array< string | null > | null,
  } | null > | null,
};

export type UserHasRoleQueryVariables = {
  role: string,
};

export type UserHasRoleQuery = {
  userHasRole?: boolean | null,
};

export type FormLayoutQueryVariables = {
  id: string,
  locationNum?: string | null,
  defaults?: Array< FormVariable | null > | null,
};

export type FormLayoutQuery = {
  formLayout?:  {
    __typename: "FormLayout",
    id: string,
    version?: number | null,
    title: string,
    usesAttachments?: boolean | null,
    confirmationMessages?: Array< string | null > | null,
    layout:  Array< {
      __typename: "FormLayoutStage",
      id: string,
      title?: string | null,
      header?: string | null,
      footer?: string | null,
      groups?:  Array< {
        __typename: "FormLayoutGroup",
        id: string,
        header?: string | null,
        footer?: string | null,
        fields:  Array<( {
            __typename: "FormLayoutInteractionField",
            id: string,
            fieldType?: FormLayoutFieldType | null,
            visible?: boolean | null,
            align?: FormLayoutFieldAlignment | null,
            header?: string | null,
            footer?: string | null,
            footerEmphasized?: boolean | null,
            styles?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
            variesBasedOn?: string | null,
            variants?:  Array< {
              __typename: string,
              key: string,
              changes:  {
                __typename: string,
                header?: string | null,
                visible?: boolean | null,
                disabled?: boolean | null,
                required?: boolean | null,
                text?: string | null,
                nextStage?: string | null,
                content?: string | null,
                input?:  {
                  __typename: string,
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  options?:  Array< {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null > | null,
                } | null,
              },
            } | null > | null,
            resetBasedOnAny?: Array< string > | null,
            usageInstructions?: string | null,
            required?: boolean | null,
          } | {
            __typename: "FormLayoutReadOnlyField",
            id: string,
            fieldType?: FormLayoutFieldType | null,
            visible?: boolean | null,
            align?: FormLayoutFieldAlignment | null,
            header?: string | null,
            footer?: string | null,
            footerEmphasized?: boolean | null,
            styles?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
            variesBasedOn?: string | null,
            variants?:  Array< {
              __typename: string,
              key: string,
              changes:  {
                __typename: string,
                header?: string | null,
                visible?: boolean | null,
                disabled?: boolean | null,
                required?: boolean | null,
                text?: string | null,
                nextStage?: string | null,
                content?: string | null,
                input?:  {
                  __typename: string,
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  options?:  Array< {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null > | null,
                } | null,
              },
            } | null > | null,
            resetBasedOnAny?: Array< string > | null,
            text?: string | null,
          } | {
            __typename: "FormLayoutInputField",
            id: string,
            fieldType?: FormLayoutFieldType | null,
            visible?: boolean | null,
            align?: FormLayoutFieldAlignment | null,
            header?: string | null,
            footer?: string | null,
            footerEmphasized?: boolean | null,
            styles?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
            variesBasedOn?: string | null,
            variants?:  Array< {
              __typename: string,
              key: string,
              changes:  {
                __typename: string,
                header?: string | null,
                visible?: boolean | null,
                disabled?: boolean | null,
                required?: boolean | null,
                text?: string | null,
                nextStage?: string | null,
                content?: string | null,
                input?:  {
                  __typename: string,
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  options?:  Array< {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null > | null,
                } | null,
              },
            } | null > | null,
            resetBasedOnAny?: Array< string > | null,
            submissionField?: string | null,
            alternateSubmissionField?: string | null,
            disabled?: boolean | null,
            required?: boolean | null,
            inputProperties: ( {
                __typename: "FormLayoutInputFieldInputDate",
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                format?: string | null,
                disabled?: string | null,
                ruleSet?: string | null,
                defaultDate?: string | null,
                // Represents the date to be pre-selected/displayed on the form datepicker by default
                startDate?: string | null,
                // Represents the start date in the range of dates to be enabled on the form datepicker
                endDate?: string | null,
                // Represents the end date in the range of dates to be enabled on the form datepicker
                excludedDates?: Array< string | null > | null,
              } | {
                __typename: "FormLayoutInputFieldInputPhone",
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                mask?: string | null,
                placeholderText?: string | null,
              } | {
                __typename: "FormLayoutInputFieldInputTextTypeahead",
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                placeholderText?: string | null,
                maxLines?: number | null,
                maxCharacters?: number | null,
                query?: string | null,
              } | {
                __typename: "FormLayoutInputFieldInputSelect",
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                options?:  Array< {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null > | null,
                interactionType?: FormLayoutInputFieldInputSelectInteraction | null,
                namedSupportingText?: string | null,
                genericSupportingText?: string | null,
                manualEntryRoute?: boolean | null,
                manualEntryStage?: string | null,
                manualOption?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                preSearchText?: string | null,
                filters?:  Array< {
                  __typename: string,
                  label: string,
                  subLabel?: string | null,
                  keyword: string,
                  sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
                } | null > | null,
                sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
              } | {
                __typename: "FormLayoutInputFieldInputMultiSelectSearch",
                // default selected options, comma separated
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                options?:  Array< {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null > | null,
                // placeholder prompt for the input field when no default, e.g. "Add one or more team member(s)..."
                placeholderText?: string | null,
                // search header, e.g. "Select Team Member(s)"
                searchHeader?: string | null,
                // search placeholder prompt, e.g. "Search team members..."
                searchPlaceholderText?: string | null,
                sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
              } | {
                __typename: "FormLayoutInputFieldInputText",
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                placeholderText?: string | null,
                minCharacters?: number | null,
                // inclusive; no restriction when null
                maxLines?: number | null,
                maxCharacters?: number | null,
                hideMaxCharactersCount?: boolean | null,
                keyboard?: FormLayoutInputFieldInputTextKeyboard | null,
                minNumericValue?: number | null,
              } | {
                __typename: "FormLayoutInputFieldInputBool",
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
              } | {
                __typename: "FormLayoutInputFieldInputMultiSelect",
                // default selected options, comma separated
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                options?:  Array< {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null > | null,
                // placeholder prompt for the input field when no default, e.g. "Select all that apply"
                placeholderText?: string | null,
              } | {
                __typename: "FormLayoutInputFieldInputTime",
                current?:  {
                  __typename: string,
                  label?: string | null,
                  supportingLabels?: Array< string | null > | null,
                  value?: string | null,
                  filterSets?: Array< string | null > | null,
                  matches?: Array< string | null > | null,
                  hiddenMatches?: Array< string | null > | null,
                } | null,
                ruleSet?: string | null,
                format?: string | null,
              }
            ),
          } | {
            __typename: "FormLayoutTableField",
            id: string,
            fieldType?: FormLayoutFieldType | null,
            visible?: boolean | null,
            align?: FormLayoutFieldAlignment | null,
            header?: string | null,
            footer?: string | null,
            footerEmphasized?: boolean | null,
            styles?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
            variesBasedOn?: string | null,
            variants?:  Array< {
              __typename: string,
              key: string,
              changes:  {
                __typename: string,
                header?: string | null,
                visible?: boolean | null,
                disabled?: boolean | null,
                required?: boolean | null,
                text?: string | null,
                nextStage?: string | null,
                content?: string | null,
                input?:  {
                  __typename: string,
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  options?:  Array< {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null > | null,
                } | null,
              },
            } | null > | null,
            resetBasedOnAny?: Array< string > | null,
            content?: string | null,
          }
        ) | null > | null,
        styles?:  Array< {
          __typename: "Option",
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null > | null,
        submissionFields?: Array< string | null > | null,
        orientation?: FormLayoutOrientation | null,
        required?: boolean | null,
      } | null > | null,
      styles?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
      submissionFields?: Array< string | null > | null,
      required?: boolean | null,
      proceedOnAnyRequired?: boolean | null,
      visible?: boolean | null,
      supportingData?: string | null,
      nextStage?: string | null,
      variesBasedOn?: string | null,
      variants?:  Array< {
        __typename: "FormLayoutVariant",
        key: string,
        changes:  {
          __typename: "FormLayoutVariantChanges",
          header?: string | null,
          visible?: boolean | null,
          disabled?: boolean | null,
          required?: boolean | null,
          text?: string | null,
          nextStage?: string | null,
          content?: string | null,
          input?:  {
            __typename: "FormLayoutVariantOption",
            current?:  {
              __typename: "Option",
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null,
            options?:  Array< {
              __typename: "Option",
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          } | null,
        },
      } | null > | null,
      asides?:  Array< {
        __typename: "FormLayoutStageAside",
        id: string,
        header?: string | null,
        footer?: string | null,
        groups?:  Array< {
          __typename: "FormLayoutGroup",
          id: string,
          header?: string | null,
          footer?: string | null,
          fields:  Array<( {
              __typename: "FormLayoutInteractionField",
              id: string,
              fieldType?: FormLayoutFieldType | null,
              visible?: boolean | null,
              align?: FormLayoutFieldAlignment | null,
              header?: string | null,
              footer?: string | null,
              footerEmphasized?: boolean | null,
              styles?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
              variesBasedOn?: string | null,
              variants?:  Array< {
                __typename: string,
                key: string,
                changes:  {
                  __typename: string,
                  header?: string | null,
                  visible?: boolean | null,
                  disabled?: boolean | null,
                  required?: boolean | null,
                  text?: string | null,
                  nextStage?: string | null,
                  content?: string | null,
                  input?:  {
                    __typename: string,
                    current?:  {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null,
                    options?:  Array< {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null > | null,
                  } | null,
                },
              } | null > | null,
              resetBasedOnAny?: Array< string > | null,
              usageInstructions?: string | null,
              required?: boolean | null,
            } | {
              __typename: "FormLayoutReadOnlyField",
              id: string,
              fieldType?: FormLayoutFieldType | null,
              visible?: boolean | null,
              align?: FormLayoutFieldAlignment | null,
              header?: string | null,
              footer?: string | null,
              footerEmphasized?: boolean | null,
              styles?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
              variesBasedOn?: string | null,
              variants?:  Array< {
                __typename: string,
                key: string,
                changes:  {
                  __typename: string,
                  header?: string | null,
                  visible?: boolean | null,
                  disabled?: boolean | null,
                  required?: boolean | null,
                  text?: string | null,
                  nextStage?: string | null,
                  content?: string | null,
                  input?:  {
                    __typename: string,
                    current?:  {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null,
                    options?:  Array< {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null > | null,
                  } | null,
                },
              } | null > | null,
              resetBasedOnAny?: Array< string > | null,
              text?: string | null,
            } | {
              __typename: "FormLayoutInputField",
              id: string,
              fieldType?: FormLayoutFieldType | null,
              visible?: boolean | null,
              align?: FormLayoutFieldAlignment | null,
              header?: string | null,
              footer?: string | null,
              footerEmphasized?: boolean | null,
              styles?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
              variesBasedOn?: string | null,
              variants?:  Array< {
                __typename: string,
                key: string,
                changes:  {
                  __typename: string,
                  header?: string | null,
                  visible?: boolean | null,
                  disabled?: boolean | null,
                  required?: boolean | null,
                  text?: string | null,
                  nextStage?: string | null,
                  content?: string | null,
                  input?:  {
                    __typename: string,
                    current?:  {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null,
                    options?:  Array< {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null > | null,
                  } | null,
                },
              } | null > | null,
              resetBasedOnAny?: Array< string > | null,
              submissionField?: string | null,
              alternateSubmissionField?: string | null,
              disabled?: boolean | null,
              required?: boolean | null,
              inputProperties: ( {
                  __typename: "FormLayoutInputFieldInputDate",
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  format?: string | null,
                  disabled?: string | null,
                  ruleSet?: string | null,
                  defaultDate?: string | null,
                  // Represents the date to be pre-selected/displayed on the form datepicker by default
                  startDate?: string | null,
                  // Represents the start date in the range of dates to be enabled on the form datepicker
                  endDate?: string | null,
                  // Represents the end date in the range of dates to be enabled on the form datepicker
                  excludedDates?: Array< string | null > | null,
                } | {
                  __typename: "FormLayoutInputFieldInputPhone",
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  mask?: string | null,
                  placeholderText?: string | null,
                } | {
                  __typename: "FormLayoutInputFieldInputTextTypeahead",
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  placeholderText?: string | null,
                  maxLines?: number | null,
                  maxCharacters?: number | null,
                  query?: string | null,
                } | {
                  __typename: "FormLayoutInputFieldInputSelect",
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  options?:  Array< {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null > | null,
                  interactionType?: FormLayoutInputFieldInputSelectInteraction | null,
                  namedSupportingText?: string | null,
                  genericSupportingText?: string | null,
                  manualEntryRoute?: boolean | null,
                  manualEntryStage?: string | null,
                  manualOption?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  preSearchText?: string | null,
                  filters?:  Array< {
                    __typename: string,
                    label: string,
                    subLabel?: string | null,
                    keyword: string,
                    sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
                  } | null > | null,
                  sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
                } | {
                  __typename: "FormLayoutInputFieldInputMultiSelectSearch",
                  // default selected options, comma separated
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  options?:  Array< {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null > | null,
                  // placeholder prompt for the input field when no default, e.g. "Add one or more team member(s)..."
                  placeholderText?: string | null,
                  // search header, e.g. "Select Team Member(s)"
                  searchHeader?: string | null,
                  // search placeholder prompt, e.g. "Search team members..."
                  searchPlaceholderText?: string | null,
                  sortStrategy?: FormLayoutInputFieldInputSelectSortStrategy | null,
                } | {
                  __typename: "FormLayoutInputFieldInputText",
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  placeholderText?: string | null,
                  minCharacters?: number | null,
                  // inclusive; no restriction when null
                  maxLines?: number | null,
                  maxCharacters?: number | null,
                  hideMaxCharactersCount?: boolean | null,
                  keyboard?: FormLayoutInputFieldInputTextKeyboard | null,
                  minNumericValue?: number | null,
                } | {
                  __typename: "FormLayoutInputFieldInputBool",
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                } | {
                  __typename: "FormLayoutInputFieldInputMultiSelect",
                  // default selected options, comma separated
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  options?:  Array< {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null > | null,
                  // placeholder prompt for the input field when no default, e.g. "Select all that apply"
                  placeholderText?: string | null,
                } | {
                  __typename: "FormLayoutInputFieldInputTime",
                  current?:  {
                    __typename: string,
                    label?: string | null,
                    supportingLabels?: Array< string | null > | null,
                    value?: string | null,
                    filterSets?: Array< string | null > | null,
                    matches?: Array< string | null > | null,
                    hiddenMatches?: Array< string | null > | null,
                  } | null,
                  ruleSet?: string | null,
                  format?: string | null,
                }
              ),
            } | {
              __typename: "FormLayoutTableField",
              id: string,
              fieldType?: FormLayoutFieldType | null,
              visible?: boolean | null,
              align?: FormLayoutFieldAlignment | null,
              header?: string | null,
              footer?: string | null,
              footerEmphasized?: boolean | null,
              styles?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
              variesBasedOn?: string | null,
              variants?:  Array< {
                __typename: string,
                key: string,
                changes:  {
                  __typename: string,
                  header?: string | null,
                  visible?: boolean | null,
                  disabled?: boolean | null,
                  required?: boolean | null,
                  text?: string | null,
                  nextStage?: string | null,
                  content?: string | null,
                  input?:  {
                    __typename: string,
                    current?:  {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null,
                    options?:  Array< {
                      __typename: string,
                      label?: string | null,
                      supportingLabels?: Array< string | null > | null,
                      value?: string | null,
                      filterSets?: Array< string | null > | null,
                      matches?: Array< string | null > | null,
                      hiddenMatches?: Array< string | null > | null,
                    } | null > | null,
                  } | null,
                },
              } | null > | null,
              resetBasedOnAny?: Array< string > | null,
              content?: string | null,
            }
          ) | null > | null,
          styles?:  Array< {
            __typename: "Option",
            label?: string | null,
            supportingLabels?: Array< string | null > | null,
            value?: string | null,
            filterSets?: Array< string | null > | null,
            matches?: Array< string | null > | null,
            hiddenMatches?: Array< string | null > | null,
          } | null > | null,
          submissionFields?: Array< string | null > | null,
          orientation?: FormLayoutOrientation | null,
          required?: boolean | null,
        } | null > | null,
        styles?:  Array< {
          __typename: "Option",
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null > | null,
      } | null > | null,
    } | null >,
    variables:  Array< {
      __typename: "FormEntryVariable",
      id: string,
      value?: string | null,
      displayValue?: string | null,
      description?: string | null,
      sensitive?: boolean | null,
    } | null >,
    startingStage?: string | null,
    reloadOnLocationChange?: boolean | null,
  } | null,
};

export type SearchAllSupportQueryVariables = {
  contains: string,
  context?: Array< SupportSearchContext | null > | null,
  ignoreTrackSearch?: boolean | null,
};

export type SearchAllSupportQuery = {
  searchAllSupport?:  {
    __typename: "SupportSearchResult",
    articles?:  Array< {
      __typename: "Article",
      id: string,
      number: string,
      title: string,
      solutionContent?: string | null,
      visibility?: ArticleVisibility | null,
      preview?: string | null,
      searchQueryId?: string | null,
      searchResultId?: string | null,
    } | null > | null,
    forms?:  Array< {
      __typename: "SupportCategory",
      id: string,
      label?: string | null,
      description?: string | null,
      imageName?: string | null,
      url: string,
      form?:  {
        __typename: "SupportCategoryForm",
        id: string,
        minimumAppVersion?: string | null,
        introContents?:  {
          __typename: "SupportCategoryFormIntro",
          header?: string | null,
          body?:  Array< {
            __typename: "SupportCategoryFormIntroRow",
            text?: string | null,
            imageName?: string | null,
          } | null > | null,
        } | null,
        showIntroOnLoad?: boolean | null,
        dynamicLayout?: boolean | null,
        caseCategory?: string | null,
        defaults?:  Array< {
          __typename: "FormEntryVariable",
          id: string,
          value?: string | null,
          displayValue?: string | null,
          description?: string | null,
          sensitive?: boolean | null,
        } | null > | null,
      } | null,
      items?:  Array< {
        __typename: "SupportCategory",
        id: string,
        label?: string | null,
        description?: string | null,
        imageName?: string | null,
        url: string,
        form?:  {
          __typename: "SupportCategoryForm",
          id: string,
          minimumAppVersion?: string | null,
          introContents?:  {
            __typename: "SupportCategoryFormIntro",
            header?: string | null,
            body?:  Array< {
              __typename: "SupportCategoryFormIntroRow",
              text?: string | null,
              imageName?: string | null,
            } | null > | null,
          } | null,
          showIntroOnLoad?: boolean | null,
          dynamicLayout?: boolean | null,
          caseCategory?: string | null,
          defaults?:  Array< {
            __typename: "FormEntryVariable",
            id: string,
            value?: string | null,
            displayValue?: string | null,
            description?: string | null,
            sensitive?: boolean | null,
          } | null > | null,
        } | null,
        items?:  Array< {
          __typename: "SupportCategory",
          id: string,
          label?: string | null,
          description?: string | null,
          imageName?: string | null,
          url: string,
          form?:  {
            __typename: "SupportCategoryForm",
            id: string,
            minimumAppVersion?: string | null,
            introContents?:  {
              __typename: "SupportCategoryFormIntro",
              header?: string | null,
              body?:  Array< {
                __typename: "SupportCategoryFormIntroRow",
                text?: string | null,
                imageName?: string | null,
              } | null > | null,
            } | null,
            showIntroOnLoad?: boolean | null,
            dynamicLayout?: boolean | null,
            caseCategory?: string | null,
            defaults?:  Array< {
              __typename: "FormEntryVariable",
              id: string,
              value?: string | null,
              displayValue?: string | null,
              description?: string | null,
              sensitive?: boolean | null,
            } | null > | null,
          } | null,
          items?:  Array< {
            __typename: "SupportCategory",
            id: string,
            label?: string | null,
            description?: string | null,
            imageName?: string | null,
            url: string,
            form?:  {
              __typename: "SupportCategoryForm",
              id: string,
              minimumAppVersion?: string | null,
              introContents?:  {
                __typename: "SupportCategoryFormIntro",
                header?: string | null,
                body?:  Array< {
                  __typename: "SupportCategoryFormIntroRow",
                  text?: string | null,
                  imageName?: string | null,
                } | null > | null,
              } | null,
              showIntroOnLoad?: boolean | null,
              dynamicLayout?: boolean | null,
              caseCategory?: string | null,
              defaults?:  Array< {
                __typename: "FormEntryVariable",
                id: string,
                value?: string | null,
                displayValue?: string | null,
                description?: string | null,
                sensitive?: boolean | null,
              } | null > | null,
            } | null,
            items?:  Array< {
              __typename: "SupportCategory",
              id: string,
              label?: string | null,
              description?: string | null,
              imageName?: string | null,
              url: string,
              form?:  {
                __typename: "SupportCategoryForm",
                id: string,
                minimumAppVersion?: string | null,
                introContents?:  {
                  __typename: "SupportCategoryFormIntro",
                  header?: string | null,
                  body?:  Array< {
                    __typename: "SupportCategoryFormIntroRow",
                    text?: string | null,
                    imageName?: string | null,
                  } | null > | null,
                } | null,
                showIntroOnLoad?: boolean | null,
                dynamicLayout?: boolean | null,
                caseCategory?: string | null,
                defaults?:  Array< {
                  __typename: "FormEntryVariable",
                  id: string,
                  value?: string | null,
                  displayValue?: string | null,
                  description?: string | null,
                  sensitive?: boolean | null,
                } | null > | null,
              } | null,
              items?:  Array< {
                __typename: "SupportCategory",
                id: string,
                label?: string | null,
                description?: string | null,
                imageName?: string | null,
                url: string,
                form?:  {
                  __typename: "SupportCategoryForm",
                  id: string,
                  minimumAppVersion?: string | null,
                  introContents?:  {
                    __typename: "SupportCategoryFormIntro",
                    header?: string | null,
                    body?:  Array< {
                      __typename: "SupportCategoryFormIntroRow",
                      text?: string | null,
                      imageName?: string | null,
                    } | null > | null,
                  } | null,
                  showIntroOnLoad?: boolean | null,
                  dynamicLayout?: boolean | null,
                  caseCategory?: string | null,
                  defaults?:  Array< {
                    __typename: "FormEntryVariable",
                    id: string,
                    value?: string | null,
                    displayValue?: string | null,
                    description?: string | null,
                    sensitive?: boolean | null,
                  } | null > | null,
                } | null,
                items?:  Array< {
                  __typename: "SupportCategory",
                  id: string,
                  label?: string | null,
                  description?: string | null,
                  imageName?: string | null,
                  url: string,
                  form?:  {
                    __typename: "SupportCategoryForm",
                    id: string,
                    minimumAppVersion?: string | null,
                    introContents?:  {
                      __typename: "SupportCategoryFormIntro",
                      header?: string | null,
                    } | null,
                    showIntroOnLoad?: boolean | null,
                    dynamicLayout?: boolean | null,
                    caseCategory?: string | null,
                    defaults?:  Array< {
                      __typename: "FormEntryVariable",
                      id: string,
                      value?: string | null,
                      displayValue?: string | null,
                      description?: string | null,
                      sensitive?: boolean | null,
                    } | null > | null,
                  } | null,
                  items?:  Array< {
                    __typename: "SupportCategory",
                    id: string,
                    label?: string | null,
                    description?: string | null,
                    imageName?: string | null,
                    url: string,
                    form?:  {
                      __typename: "SupportCategoryForm",
                      id: string,
                      minimumAppVersion?: string | null,
                      showIntroOnLoad?: boolean | null,
                      dynamicLayout?: boolean | null,
                      caseCategory?: string | null,
                    } | null,
                    items?:  Array< {
                      __typename: "SupportCategory",
                      id: string,
                      label?: string | null,
                      description?: string | null,
                      imageName?: string | null,
                      url: string,
                      featuredOrder?: number | null,
                      recentlyFeaturedOrder?: number | null,
                      commonlyUsedOrder?: number | null,
                      recommendedOrder?: number | null,
                      isFeatured?: boolean | null,
                      labelAccoutrement?: string | null,
                      caseCategory?: string | null,
                    } | null > | null,
                    featuredOrder?: number | null,
                    recentlyFeaturedOrder?: number | null,
                    commonlyUsedOrder?: number | null,
                    recommendedOrder?: number | null,
                    isFeatured?: boolean | null,
                    labelAccoutrement?: string | null,
                    caseCategory?: string | null,
                  } | null > | null,
                  featuredOrder?: number | null,
                  recentlyFeaturedOrder?: number | null,
                  commonlyUsedOrder?: number | null,
                  recommendedOrder?: number | null,
                  isFeatured?: boolean | null,
                  labelAccoutrement?: string | null,
                  caseCategory?: string | null,
                } | null > | null,
                featuredOrder?: number | null,
                recentlyFeaturedOrder?: number | null,
                commonlyUsedOrder?: number | null,
                recommendedOrder?: number | null,
                isFeatured?: boolean | null,
                labelAccoutrement?: string | null,
                caseCategory?: string | null,
              } | null > | null,
              featuredOrder?: number | null,
              recentlyFeaturedOrder?: number | null,
              commonlyUsedOrder?: number | null,
              recommendedOrder?: number | null,
              isFeatured?: boolean | null,
              labelAccoutrement?: string | null,
              caseCategory?: string | null,
            } | null > | null,
            featuredOrder?: number | null,
            recentlyFeaturedOrder?: number | null,
            commonlyUsedOrder?: number | null,
            recommendedOrder?: number | null,
            isFeatured?: boolean | null,
            labelAccoutrement?: string | null,
            caseCategory?: string | null,
          } | null > | null,
          featuredOrder?: number | null,
          recentlyFeaturedOrder?: number | null,
          commonlyUsedOrder?: number | null,
          recommendedOrder?: number | null,
          isFeatured?: boolean | null,
          labelAccoutrement?: string | null,
          caseCategory?: string | null,
        } | null > | null,
        featuredOrder?: number | null,
        recentlyFeaturedOrder?: number | null,
        commonlyUsedOrder?: number | null,
        recommendedOrder?: number | null,
        isFeatured?: boolean | null,
        labelAccoutrement?: string | null,
        caseCategory?: string | null,
      } | null > | null,
      featuredOrder?: number | null,
      recentlyFeaturedOrder?: number | null,
      commonlyUsedOrder?: number | null,
      recommendedOrder?: number | null,
      isFeatured?: boolean | null,
      labelAccoutrement?: string | null,
      caseCategory?: string | null,
    } | null > | null,
    searchResultCases?:  Array< {
      __typename: "SupportSearchResultCase",
      id: string,
      number: string,
      status: CaseStatus,
      description: string,
      longDescription?: string | null,
      commentPreview?: string | null,
      openedOn?: string | null,
      updatedOn: string,
      confidential?: boolean | null,
      locationNum?: string | null,
      contact?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
    } | null > | null,
  } | null,
};

export type SearchCasesQueryVariables = {
  contains: string,
  filters?: SearchCaseFilters | null,
};

export type SearchCasesQuery = {
  searchCases?:  Array< {
    __typename: "SupportSearchResultCase",
    id: string,
    number: string,
    status: CaseStatus,
    description: string,
    longDescription?: string | null,
    commentPreview?: string | null,
    openedOn?: string | null,
    updatedOn: string,
    confidential?: boolean | null,
    locationNum?: string | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
  } | null > | null,
};

export type SearchesRecentQueryVariables = {
  userGuid: string,
};

export type SearchesRecentQuery = {
  searchesRecent: Array< string | null >,
};

export type AppointmentsQueryVariables = {
  locationNums?: Array< string | null > | null,
};

export type AppointmentsQuery = {
  appointments:  Array< {
    __typename: "Appointment",
    id: string,
    caseNumber?: string | null,
    subject?: string | null,
    description?: string | null,
    contact?: string | null,
    status?: AppointmentStatus | null,
    dueDate?: string | null,
    technician?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    restaurant?:  {
      __typename: "Restaurant",
      id?: string | null,
      number: string,
      name?: string | null,
      contacts?:  Array< {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null > | null,
      siteProperties?:  {
        __typename: "RestaurantSite",
        lat?: number | null,
        long?: number | null,
        countryCode?: string | null,
        utcOffset?: string | null,
        tzId?: string | null,
      } | null,
      openCasesCount?: number | null,
      operator?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      supportDeskPhoneNumber?: string | null,
    } | null,
  } | null >,
};

export type AppointmentQueryVariables = {
  id: string,
};

export type AppointmentQuery = {
  appointment?:  {
    __typename: "Appointment",
    id: string,
    caseNumber?: string | null,
    subject?: string | null,
    description?: string | null,
    contact?: string | null,
    status?: AppointmentStatus | null,
    dueDate?: string | null,
    technician?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    restaurant?:  {
      __typename: "Restaurant",
      id?: string | null,
      number: string,
      name?: string | null,
      contacts?:  Array< {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null > | null,
      siteProperties?:  {
        __typename: "RestaurantSite",
        lat?: number | null,
        long?: number | null,
        countryCode?: string | null,
        utcOffset?: string | null,
        tzId?: string | null,
      } | null,
      openCasesCount?: number | null,
      operator?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      supportDeskPhoneNumber?: string | null,
    } | null,
  } | null,
};

export type ProgramMembershipsQueryVariables = {
  locationNums?: Array< string | null > | null,
  userGuid?: string | null,
};

export type ProgramMembershipsQuery = {
  programMemberships:  {
    __typename: "ProgramMemberships",
    locationMemberships?:  Array< {
      __typename: "ProgramMembershipRestaurant",
      program: Program,
      locationNum: string,
    } | null > | null,
    userMemberships?:  Array< {
      __typename: "ProgramMembershipUser",
      program: Program,
      guid: string,
    } | null > | null,
  },
};

export type AssetQueryVariables = {
  tag: string,
  markViewed?: boolean | null,
};

export type AssetQuery = {
  asset?:  {
    __typename: "Asset",
    id: string,
    tag?: string | null,
    csiCode?: string | null,
    serial: string,
    name: string,
    locationNum: string,
    type:  {
      __typename: "AssetType",
      id: string,
      name: string,
      imageURL?: string | null,
      family?: string | null,
    },
    model?:  {
      __typename: "AssetModel",
      id: string,
      imageURL?: string | null,
      allowAdditionalEquipmentRequest: boolean,
    } | null,
    manufacturer?: string | null,
    relatedCases:  Array<( {
        __typename: "MinorCaseType",
        id: string,
        number: string,
        locationNum: string,
      } | {
        __typename: "SubmitFormResponseType",
        id: string,
        number: string,
        confirmationMessages?: Array< string | null > | null,
      } | {
        __typename: "AssetCaseType",
        id: string,
        number: string,
        description: string,
      }
    ) | null > | null,
    department?: string | null,
    resources?:  Array< {
      __typename: "AssetResource",
      key: string,
      externalURL: string,
      imageName?: string | null,
      label: string,
    } | null > | null,
    flowInfo?:  {
      __typename: "TroubleshootingFlowInfo",
      flowId: string,
      flowName: string,
      title: string,
      description: string,
      thumbnailImageURL: string,
      minimumAppVersion: string,
    } | null,
    // null if no flow available; first flow info if multiple
    flowInfos?:  Array< {
      __typename: "TroubleshootingFlowInfo",
      flowId: string,
      flowName: string,
      title: string,
      description: string,
      thumbnailImageURL: string,
      minimumAppVersion: string,
    } > | null,
  } | null,
};

export type AssetByIdQueryVariables = {
  id: string,
  markViewed?: boolean | null,
};

export type AssetByIdQuery = {
  assetById?:  {
    __typename: "Asset",
    id: string,
    tag?: string | null,
    csiCode?: string | null,
    serial: string,
    name: string,
    locationNum: string,
    type:  {
      __typename: "AssetType",
      id: string,
      name: string,
      imageURL?: string | null,
      family?: string | null,
    },
    model?:  {
      __typename: "AssetModel",
      id: string,
      imageURL?: string | null,
      allowAdditionalEquipmentRequest: boolean,
    } | null,
    manufacturer?: string | null,
    relatedCases:  Array<( {
        __typename: "MinorCaseType",
        id: string,
        number: string,
        locationNum: string,
      } | {
        __typename: "SubmitFormResponseType",
        id: string,
        number: string,
        confirmationMessages?: Array< string | null > | null,
      } | {
        __typename: "AssetCaseType",
        id: string,
        number: string,
        description: string,
      }
    ) | null > | null,
    department?: string | null,
    resources?:  Array< {
      __typename: "AssetResource",
      key: string,
      externalURL: string,
      imageName?: string | null,
      label: string,
    } | null > | null,
    flowInfo?:  {
      __typename: "TroubleshootingFlowInfo",
      flowId: string,
      flowName: string,
      title: string,
      description: string,
      thumbnailImageURL: string,
      minimumAppVersion: string,
    } | null,
    // null if no flow available; first flow info if multiple
    flowInfos?:  Array< {
      __typename: "TroubleshootingFlowInfo",
      flowId: string,
      flowName: string,
      title: string,
      description: string,
      thumbnailImageURL: string,
      minimumAppVersion: string,
    } > | null,
  } | null,
};

export type AssetsQueryVariables = {
  locationNums: Array< string | null >,
  csiCode?: string | null,
};

export type AssetsQuery = {
  assets:  Array< {
    __typename: "Asset",
    id: string,
    tag?: string | null,
    csiCode?: string | null,
    serial: string,
    name: string,
    locationNum: string,
    type:  {
      __typename: "AssetType",
      id: string,
      name: string,
      imageURL?: string | null,
      family?: string | null,
    },
    model?:  {
      __typename: "AssetModel",
      id: string,
      imageURL?: string | null,
      allowAdditionalEquipmentRequest: boolean,
    } | null,
    manufacturer?: string | null,
    relatedCases:  Array<( {
        __typename: "MinorCaseType",
        id: string,
        number: string,
        locationNum: string,
      } | {
        __typename: "SubmitFormResponseType",
        id: string,
        number: string,
        confirmationMessages?: Array< string | null > | null,
      } | {
        __typename: "AssetCaseType",
        id: string,
        number: string,
        description: string,
      }
    ) | null > | null,
    department?: string | null,
    resources?:  Array< {
      __typename: "AssetResource",
      key: string,
      externalURL: string,
      imageName?: string | null,
      label: string,
    } | null > | null,
    flowInfo?:  {
      __typename: "TroubleshootingFlowInfo",
      flowId: string,
      flowName: string,
      title: string,
      description: string,
      thumbnailImageURL: string,
      minimumAppVersion: string,
    } | null,
    // null if no flow available; first flow info if multiple
    flowInfos?:  Array< {
      __typename: "TroubleshootingFlowInfo",
      flowId: string,
      flowName: string,
      title: string,
      description: string,
      thumbnailImageURL: string,
      minimumAppVersion: string,
    } > | null,
  } | null >,
};

export type AssetsRecentQueryVariables = {
  userGuid: string,
};

export type AssetsRecentQuery = {
  assetsRecent:  Array< {
    __typename: "AssetViewed",
    id: string,
    tag?: string | null,
    serial?: string | null,
    locationNum: string,
    viewedOn: string,
  } | null >,
};

export type AssetAlertQueryVariables = {
  id: string,
};

export type AssetAlertQuery = {
  assetAlert?:  {
    __typename: "AssetAlert",
    id: string,
    locationNum: string,
    locationName: string,
    action: AssetAlertAction,
    actor: string,
    createdOn: string,
    summary: string,
    deviceType: string,
    detail?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type AssetResourcesQueryVariables = {
  locationNum: string,
};

export type AssetResourcesQuery = {
  assetResources:  Array< {
    __typename: "AssetResource",
    key: string,
    externalURL: string,
    imageName?: string | null,
    label: string,
  } | null >,
};

export type AssetWarrantiesQueryVariables = {
  assetId: string,
};

export type AssetWarrantiesQuery = {
  assetWarranties:  Array< {
    __typename: "AssetWarranty",
    id: string,
    // opaque guid from Asset API
    type: AssetWarrantyType,
    name: string,
    status: AssetWarrantyStatus,
    expiresOn?: string | null,
    termMonths?: number | null,
    coverage?:  {
      __typename: "AssetWarrantyCoverage",
      header: string,
      body: string,
    } | null,
  } | null >,
};

export type AssetServiceHistoryQueryVariables = {
  assetId: string,
  locationNum: string,
};

export type AssetServiceHistoryQuery = {
  assetServiceHistory:  {
    __typename: "AssetServiceHistory",
    assetId: string,
    locationNum: string,
    events:  Array< {
      __typename: "AssetServiceEvent",
      id: string,
      // opaque guid from Asset API
      assetId: string,
      locationNum: string,
      status: AssetServiceEventStatus,
      costUSD: string,
      serviceDate: string,
      issue?: string | null,
      resolution?: string | null,
      technicianName?: string | null,
      source?: AssetServiceEventSource | null,
      vendor?: string | null,
      createdOn?: string | null,
      updatedOn?: string | null,
      createdBy?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      updatedBy?:  {
        __typename: "User",
        id: string,
        firstName: string,
        lastName?: string | null,
        fullName?: string | null,
        guid?: string | null,
        userName?: string | null,
        audience: Audience,
        personId?: string | null,
        photoURL?: string | null,
        photo?: string | null,
        mobilePhone?: string | null,
        email?: string | null,
        title?: string | null,
      } | null,
      attachments?:  Array< {
        __typename: "AttachmentDownload",
        id: string,
        fileName: string,
        mimeType: string,
        downloadUrl: string,
        scheme: AttachmentScheme,
      } | null > | null,
    } | null >,
    totalCostUSD: string,
  },
};

export type AssetServiceEventQueryVariables = {
  eventId: string,
};

export type AssetServiceEventQuery = {
  assetServiceEvent?:  {
    __typename: "AssetServiceEvent",
    id: string,
    // opaque guid from Asset API
    assetId: string,
    locationNum: string,
    status: AssetServiceEventStatus,
    costUSD: string,
    serviceDate: string,
    issue?: string | null,
    resolution?: string | null,
    technicianName?: string | null,
    source?: AssetServiceEventSource | null,
    vendor?: string | null,
    createdOn?: string | null,
    updatedOn?: string | null,
    createdBy?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    updatedBy?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    attachments?:  Array< {
      __typename: "AttachmentDownload",
      id: string,
      fileName: string,
      mimeType: string,
      downloadUrl: string,
      scheme: AttachmentScheme,
    } | null > | null,
  } | null,
};

export type FacilityCategoriesQueryVariables = {
};

export type FacilityCategoriesQuery = {
  facilityCategories:  Array< {
    __typename: "FacilityCategory",
    type: FacilityCategoryType,
    label: string,
    order: number,
    getSupportURL: string,
    matches?: Array< string | null > | null,
  } | null >,
};

export type ServiceHistoryAvailabilityQueryVariables = {
  locationNum: string,
};

export type ServiceHistoryAvailabilityQuery = {
  serviceHistoryAvailability: boolean,
};

export type LocationAlertsQueryVariables = {
  locationNums: Array< string | null >,
};

export type LocationAlertsQuery = {
  locationAlerts:  Array< {
    __typename: "LocationAlert",
    locationNum: string,
    assetAlerts:  Array< {
      __typename: "AssetAlert",
      id: string,
      locationNum: string,
      locationName: string,
      action: AssetAlertAction,
      actor: string,
      createdOn: string,
      summary: string,
      deviceType: string,
      detail?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null >,
  } | null >,
};

export type FlowQueryVariables = {
  flowId: string,
  assetId?: string | null,
  locationNum?: string | null,
};

export type FlowQuery = {
  // Troubleshooting
  flow:  {
    __typename: "TroubleshootingFlow",
    id: string,
    name: string,
    // e.g. PAX D190 Card Reader
    shortName?: string | null,
    // e.g. D190
    startStepId: string,
    steps:  Array< {
      __typename: "FlowStep",
      id: string,
      instructions:  Array<( {
          __typename: "DisplayTextFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          header?: string | null,
          content?: string | null,
        } | {
          __typename: "SpacingFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          spacingType: SpacingInstructionType,
        } | {
          __typename: "EquipmentInfoFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          equipmentInfoLabel?: string | null,
          modelCategoryName?: string | null,
          modelNumber?: string | null,
          manufacturer?: string | null,
          serial?: string | null,
        } | {
          __typename: "SelectSearchInputFlowInstruction",
          id: string,
          // SELECT_SEARCH_INPUT
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          flowVariableId: string,
          // input field label, e.g. "Serial number"
          label: string,
          showLabelInline: boolean,
          // placeholder prompt for the input field when no default, e.g. "Select"
          placeholderText?: string | null,
          footer?: string | null,
          // options available to show
          options:  Array< {
            __typename: string,
            label?: string | null,
            supportingLabels?: Array< string | null > | null,
            value?: string | null,
            filterSets?: Array< string | null > | null,
            matches?: Array< string | null > | null,
            hiddenMatches?: Array< string | null > | null,
          } | null >,
          // other option to show, e.g. "Serial number not shown"
          otherOption?:  {
            __typename: string,
            label?: string | null,
            supportingLabels?: Array< string | null > | null,
            value?: string | null,
            filterSets?: Array< string | null > | null,
            matches?: Array< string | null > | null,
            hiddenMatches?: Array< string | null > | null,
          } | null,
          // search header, e.g. "Select Serial Number"
          searchHeader?: string | null,
          // search placeholder prompt, e.g. "Search serial number"
          searchPlaceholderText?: string | null,
          filters?:  Array< {
            __typename: string,
            // filter tab label, e.g. "Top"
            label: string,
            // sub-label to shown within the filtered tab, e.g. "Top chosen items"
            subLabel?: string | null,
            // underlying filter value to match against on the Option, e.g. "top"
            keyword: string,
            // sort strategy to utilize when this filter tab is active
            sortStrategy?: SelectSortStrategy | null,
          } > | null,
          sortStrategy?: SelectSortStrategy | null,
          optional: boolean,
          visible: boolean,
          summaryPolicy?:  {
            __typename: string,
            // describes how to map the input value to a captured summary message
            mappings:  Array< {
              __typename: string,
              // e.g. "did_that_fix_your_issue"
              matchFlowVariableId: string,
              // e.g. "no"
              matchFlowVariableValue: string,
              // e.g. "Reseating the battery did not fix the issue."
              message: string,
            } | null >,
          } | null,
        } | {
          __typename: "SummaryInputFlowInstruction",
          id: string,
          // SUMMARY_DETAILS_INPUT
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          flowVariableId: string,
          // e.g. Troubleshooting summary
          label: string,
          detailsInput:  {
            __typename: string,
            // e.g. Additional comments or questions
            label: string,
            minLines: number,
            maxLines: number,
            // e.g. Add details...
            placeholder?: string | null,
            footer?: string | null,
            // default required unless optional=true
            optional: boolean,
          },
        } | {
          __typename: "AssetTagGraphicFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          tagNumber: string,
          state: AssetTagGraphicInstructionState,
          assetTagGraphicLabel?: string | null,
        } | {
          __typename: "LocationPickerInputFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          flowVariableId: string,
          locationPickerLabel?: string | null,
          footer?: string | null,
        } | {
          __typename: "CloseButtonFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          text: string,
          style: ButtonInstructionStyle,
        } | {
          __typename: "ImageFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          imageURL: string,
        } | {
          __typename: "MultiSelectInputFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          label: string,
          flowVariableId: string,
          options:  Array< {
            __typename: string,
            label?: string | null,
            supportingLabels?: Array< string | null > | null,
            value?: string | null,
            filterSets?: Array< string | null > | null,
            matches?: Array< string | null > | null,
            hiddenMatches?: Array< string | null > | null,
          } | null >,
          optional: boolean,
          summaryPolicy?:  {
            __typename: string,
            // describes how to format the captured summary message
            // $SUMMARY_VAL$ is a comma-joined string of the mapped summary messages described by mappings
            // e.g. template="Please contact between: $SUMMARY_VAL$."; message="Please contact between 9am to 11am, 2pm to 5pm."
            template: string,
            // describes how to map each input value selected to a corresponding summary message
            mappings:  Array< {
              __typename: string,
              // e.g. "did_that_fix_your_issue"
              matchFlowVariableId: string,
              // e.g. "no"
              matchFlowVariableValue: string,
              // e.g. "Reseating the battery did not fix the issue."
              message: string,
            } | null >,
          } | null,
        } | {
          __typename: "RestartButtonFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          text: string,
          style: ButtonInstructionStyle,
        } | {
          __typename: "InputFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          label: string,
          flowVariableId: string,
          optional: boolean,
          keyboard: TextInputInstructionKeyboard,
          minLines: number,
          maxLines: number,
          footer?: string | null,
          placeholder?: string | null,
          summaryPolicy?:  {
            __typename: string,
            // describes how to format the captured summary message
            // e.g. template="Model: $SUMMARY_VAL$"; message="Model: PFE-500"
            template: string,
            // fallback value for the $SUMMARY_VAL$ to use in summary message
            // e.g. default="Not entered"; message="Model: Not entered" if empty or null $INPUT_VALUE
            default?: string | null,
          } | null,
        } | {
          __typename: "IconFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          symbol: IconSymbol,
          color: IconColor,
          footer?: string | null,
        } | {
          __typename: "AttachmentInputFlowInstruction",
          id: string,
          // ATTACHMENT_INPUT
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          // e.g. Add a photo of your card reader
          label: string,
          // e.g. Add photos and files
          placeholder?: string | null,
          // e.g. Add up to 5 attachments
          footer?: string | null,
          maxAttachments: number,
          // assume required by default until optional=true
          optional: boolean,
        } | {
          __typename: "TicketContactPickerInputFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          flowVariableId: string,
          variesByFlowVariableId?: string | null,
          ticketContactPickerLabel?: string | null,
          footer?: string | null,
        } | {
          __typename: "AssetTagInputFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          flowVariableId: string,
          assetTagInputTitle?: string | null,
          assetTagInputLabel?: string | null,
          placeholder?: string | null,
          summaryPolicy?:  {
            __typename: string,
            // describes how to format the captured summary message
            // e.g. template="Model: $SUMMARY_VAL$"; message="Model: PFE-500"
            template: string,
            // fallback value for the $SUMMARY_VAL$ to use in summary message
            // e.g. default="Not entered"; message="Model: Not entered" if empty or null $INPUT_VALUE
            default?: string | null,
          } | null,
        } | {
          __typename: "SingleSelectInputFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          label: string,
          flowVariableId: string,
          options:  Array< {
            __typename: string,
            label?: string | null,
            supportingLabels?: Array< string | null > | null,
            value?: string | null,
            filterSets?: Array< string | null > | null,
            matches?: Array< string | null > | null,
            hiddenMatches?: Array< string | null > | null,
          } | null >,
          summaryPolicy?:  {
            __typename: string,
            // describes how to map the input value to a captured summary message
            mappings:  Array< {
              __typename: string,
              // e.g. "did_that_fix_your_issue"
              matchFlowVariableId: string,
              // e.g. "no"
              matchFlowVariableValue: string,
              // e.g. "Reseating the battery did not fix the issue."
              message: string,
            } | null >,
          } | null,
        } | {
          __typename: "KBArticleFlowInstruction",
          id: string,
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          kbNumber: string,
          title: string,
        } | {
          __typename: "FormButtonFlowInstruction",
          id: string,
          // LAUNCH_FORM
          instructionType: FlowInstructionType,
          // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
          variesBasedOn?: string | null,
          variants?:  Array< {
            __typename: string,
            key: string,
            changes:  {
              __typename: string,
              visible?: boolean | null,
              optional?: boolean | null,
              options?:  Array< {
                __typename: string,
                label?: string | null,
                supportingLabels?: Array< string | null > | null,
                value?: string | null,
                filterSets?: Array< string | null > | null,
                matches?: Array< string | null > | null,
                hiddenMatches?: Array< string | null > | null,
              } | null > | null,
            },
          } > | null,
          // e.g. Open a Ticket
          text: string,
          // e.g. PRIMARY
          style: ButtonInstructionStyle,
          formId: string,
          formDefaultMappings:  Array< {
            __typename: string,
            formVariableId: string,
            flowVariableId?: string | null,
            literalValue?: string | null,
          } | null >,
          // default submission variable for the troubleshooting summary
          formDefaultSummaryId?: string | null,
        }
      ) | null >,
      mustBranchDynamically: boolean,
      staticBranches:  Array< {
        __typename: "FlowBranch",
        id: string,
        matchConditions:  Array< {
          __typename: "FlowMatchCondition",
          flowVariableId: string,
          matchingValue?: string | null,
        } | null >,
        nextStepId: string,
      } | null >,
      branchLabelOverride?: string | null,
      isBacktrackDisabled?: boolean | null,
      // if formToSubmit not null, ignore branching
      formToSubmit?:  {
        __typename: "FlowStepForm",
        formId: string,
        formVariableMappings:  Array< {
          __typename: "FormFlowMapping",
          formVariableId: string,
          flowVariableId?: string | null,
          literalValue?: string | null,
        } | null >,
        formSummaryMapping?:  {
          __typename: "FormFlowMapping",
          formVariableId: string,
          flowVariableId?: string | null,
          literalValue?: string | null,
        } | null,
        successMessage: string,
        // override for the restart button on the success screen, e.g. "Fix another asset tag"
        restartLabelOverride?: string | null,
      } | null,
      heroImageURL?: string | null,
      defaults?:  Array< {
        __typename: "FlowVariable",
        id: string,
        value?: string | null,
      } | null > | null,
    } | null >,
    summaryMappings?:  Array< {
      __typename: "FlowSummaryMapping",
      // e.g. "did_that_fix_your_issue"
      matchFlowVariableId: string,
      // e.g. "no"
      matchFlowVariableValue: string,
      // e.g. "Reseating the battery did not fix the issue."
      message: string,
    } | null > | null,
    defaults:  Array< {
      __typename: "FlowVariable",
      id: string,
      value?: string | null,
    } | null >,
  },
};

export type FlowInfosQueryVariables = {
  locationNum: string,
};

export type FlowInfosQuery = {
  flowInfos:  Array< {
    __typename: "TroubleshootingFlowInfo",
    flowId: string,
    flowName: string,
    title: string,
    description: string,
    thumbnailImageURL: string,
    minimumAppVersion: string,
  } | null >,
};

export type NextFlowStepQueryVariables = {
  flowId: string,
  currStepId?: string | null,
  inputs: Array< FlowVariableInput | null >,
  locationNum?: string | null,
};

export type NextFlowStepQuery = {
  nextFlowStep:  {
    __typename: "FlowStep",
    id: string,
    instructions:  Array<( {
        __typename: "DisplayTextFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        header?: string | null,
        content?: string | null,
      } | {
        __typename: "SpacingFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        spacingType: SpacingInstructionType,
      } | {
        __typename: "EquipmentInfoFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        equipmentInfoLabel?: string | null,
        modelCategoryName?: string | null,
        modelNumber?: string | null,
        manufacturer?: string | null,
        serial?: string | null,
      } | {
        __typename: "SelectSearchInputFlowInstruction",
        id: string,
        // SELECT_SEARCH_INPUT
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        flowVariableId: string,
        // input field label, e.g. "Serial number"
        label: string,
        showLabelInline: boolean,
        // placeholder prompt for the input field when no default, e.g. "Select"
        placeholderText?: string | null,
        footer?: string | null,
        // options available to show
        options:  Array< {
          __typename: string,
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null >,
        // other option to show, e.g. "Serial number not shown"
        otherOption?:  {
          __typename: string,
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null,
        // search header, e.g. "Select Serial Number"
        searchHeader?: string | null,
        // search placeholder prompt, e.g. "Search serial number"
        searchPlaceholderText?: string | null,
        filters?:  Array< {
          __typename: string,
          // filter tab label, e.g. "Top"
          label: string,
          // sub-label to shown within the filtered tab, e.g. "Top chosen items"
          subLabel?: string | null,
          // underlying filter value to match against on the Option, e.g. "top"
          keyword: string,
          // sort strategy to utilize when this filter tab is active
          sortStrategy?: SelectSortStrategy | null,
        } > | null,
        sortStrategy?: SelectSortStrategy | null,
        optional: boolean,
        visible: boolean,
        summaryPolicy?:  {
          __typename: string,
          // describes how to map the input value to a captured summary message
          mappings:  Array< {
            __typename: string,
            // e.g. "did_that_fix_your_issue"
            matchFlowVariableId: string,
            // e.g. "no"
            matchFlowVariableValue: string,
            // e.g. "Reseating the battery did not fix the issue."
            message: string,
          } | null >,
        } | null,
      } | {
        __typename: "SummaryInputFlowInstruction",
        id: string,
        // SUMMARY_DETAILS_INPUT
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        flowVariableId: string,
        // e.g. Troubleshooting summary
        label: string,
        detailsInput:  {
          __typename: string,
          // e.g. Additional comments or questions
          label: string,
          minLines: number,
          maxLines: number,
          // e.g. Add details...
          placeholder?: string | null,
          footer?: string | null,
          // default required unless optional=true
          optional: boolean,
        },
      } | {
        __typename: "AssetTagGraphicFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        tagNumber: string,
        state: AssetTagGraphicInstructionState,
        assetTagGraphicLabel?: string | null,
      } | {
        __typename: "LocationPickerInputFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        flowVariableId: string,
        locationPickerLabel?: string | null,
        footer?: string | null,
      } | {
        __typename: "CloseButtonFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        text: string,
        style: ButtonInstructionStyle,
      } | {
        __typename: "ImageFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        imageURL: string,
      } | {
        __typename: "MultiSelectInputFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        label: string,
        flowVariableId: string,
        options:  Array< {
          __typename: string,
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null >,
        optional: boolean,
        summaryPolicy?:  {
          __typename: string,
          // describes how to format the captured summary message
          // $SUMMARY_VAL$ is a comma-joined string of the mapped summary messages described by mappings
          // e.g. template="Please contact between: $SUMMARY_VAL$."; message="Please contact between 9am to 11am, 2pm to 5pm."
          template: string,
          // describes how to map each input value selected to a corresponding summary message
          mappings:  Array< {
            __typename: string,
            // e.g. "did_that_fix_your_issue"
            matchFlowVariableId: string,
            // e.g. "no"
            matchFlowVariableValue: string,
            // e.g. "Reseating the battery did not fix the issue."
            message: string,
          } | null >,
        } | null,
      } | {
        __typename: "RestartButtonFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        text: string,
        style: ButtonInstructionStyle,
      } | {
        __typename: "InputFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        label: string,
        flowVariableId: string,
        optional: boolean,
        keyboard: TextInputInstructionKeyboard,
        minLines: number,
        maxLines: number,
        footer?: string | null,
        placeholder?: string | null,
        summaryPolicy?:  {
          __typename: string,
          // describes how to format the captured summary message
          // e.g. template="Model: $SUMMARY_VAL$"; message="Model: PFE-500"
          template: string,
          // fallback value for the $SUMMARY_VAL$ to use in summary message
          // e.g. default="Not entered"; message="Model: Not entered" if empty or null $INPUT_VALUE
          default?: string | null,
        } | null,
      } | {
        __typename: "IconFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        symbol: IconSymbol,
        color: IconColor,
        footer?: string | null,
      } | {
        __typename: "AttachmentInputFlowInstruction",
        id: string,
        // ATTACHMENT_INPUT
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        // e.g. Add a photo of your card reader
        label: string,
        // e.g. Add photos and files
        placeholder?: string | null,
        // e.g. Add up to 5 attachments
        footer?: string | null,
        maxAttachments: number,
        // assume required by default until optional=true
        optional: boolean,
      } | {
        __typename: "TicketContactPickerInputFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        flowVariableId: string,
        variesByFlowVariableId?: string | null,
        ticketContactPickerLabel?: string | null,
        footer?: string | null,
      } | {
        __typename: "AssetTagInputFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        flowVariableId: string,
        assetTagInputTitle?: string | null,
        assetTagInputLabel?: string | null,
        placeholder?: string | null,
        summaryPolicy?:  {
          __typename: string,
          // describes how to format the captured summary message
          // e.g. template="Model: $SUMMARY_VAL$"; message="Model: PFE-500"
          template: string,
          // fallback value for the $SUMMARY_VAL$ to use in summary message
          // e.g. default="Not entered"; message="Model: Not entered" if empty or null $INPUT_VALUE
          default?: string | null,
        } | null,
      } | {
        __typename: "SingleSelectInputFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        label: string,
        flowVariableId: string,
        options:  Array< {
          __typename: string,
          label?: string | null,
          supportingLabels?: Array< string | null > | null,
          value?: string | null,
          filterSets?: Array< string | null > | null,
          matches?: Array< string | null > | null,
          hiddenMatches?: Array< string | null > | null,
        } | null >,
        summaryPolicy?:  {
          __typename: string,
          // describes how to map the input value to a captured summary message
          mappings:  Array< {
            __typename: string,
            // e.g. "did_that_fix_your_issue"
            matchFlowVariableId: string,
            // e.g. "no"
            matchFlowVariableValue: string,
            // e.g. "Reseating the battery did not fix the issue."
            message: string,
          } | null >,
        } | null,
      } | {
        __typename: "KBArticleFlowInstruction",
        id: string,
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        kbNumber: string,
        title: string,
      } | {
        __typename: "FormButtonFlowInstruction",
        id: string,
        // LAUNCH_FORM
        instructionType: FlowInstructionType,
        // flow variable id whose value selects a variants[].key entry; null when instruction does not vary
        variesBasedOn?: string | null,
        variants?:  Array< {
          __typename: string,
          key: string,
          changes:  {
            __typename: string,
            visible?: boolean | null,
            optional?: boolean | null,
            options?:  Array< {
              __typename: string,
              label?: string | null,
              supportingLabels?: Array< string | null > | null,
              value?: string | null,
              filterSets?: Array< string | null > | null,
              matches?: Array< string | null > | null,
              hiddenMatches?: Array< string | null > | null,
            } | null > | null,
          },
        } > | null,
        // e.g. Open a Ticket
        text: string,
        // e.g. PRIMARY
        style: ButtonInstructionStyle,
        formId: string,
        formDefaultMappings:  Array< {
          __typename: string,
          formVariableId: string,
          flowVariableId?: string | null,
          literalValue?: string | null,
        } | null >,
        // default submission variable for the troubleshooting summary
        formDefaultSummaryId?: string | null,
      }
    ) | null >,
    mustBranchDynamically: boolean,
    staticBranches:  Array< {
      __typename: "FlowBranch",
      id: string,
      matchConditions:  Array< {
        __typename: "FlowMatchCondition",
        flowVariableId: string,
        matchingValue?: string | null,
      } | null >,
      nextStepId: string,
    } | null >,
    branchLabelOverride?: string | null,
    isBacktrackDisabled?: boolean | null,
    // if formToSubmit not null, ignore branching
    formToSubmit?:  {
      __typename: "FlowStepForm",
      formId: string,
      formVariableMappings:  Array< {
        __typename: "FormFlowMapping",
        formVariableId: string,
        flowVariableId?: string | null,
        literalValue?: string | null,
      } | null >,
      formSummaryMapping?:  {
        __typename: "FormFlowMapping",
        formVariableId: string,
        flowVariableId?: string | null,
        literalValue?: string | null,
      } | null,
      successMessage: string,
      // override for the restart button on the success screen, e.g. "Fix another asset tag"
      restartLabelOverride?: string | null,
    } | null,
    heroImageURL?: string | null,
    defaults?:  Array< {
      __typename: "FlowVariable",
      id: string,
      value?: string | null,
    } | null > | null,
  },
};

export type FeatureToggleEnabledQueryVariables = {
  flagKey: string,
};

export type FeatureToggleEnabledQuery = {
  // checks if feature toggle is enabled for the authenticated user
  featureToggleEnabled?: boolean | null,
};

export type HealthQueryVariables = {
};

export type HealthQuery = {
  health:  {
    __typename: "HealthSummary",
    id: string,
    status: HealthStatus,
  },
};

export type AddedActivityStreamEntrySubscriptionVariables = {
  locationNum?: string | null,
  caseId?: string | null,
};

export type AddedActivityStreamEntrySubscription = {
  addedActivityStreamEntry?:  {
    __typename: "ActivityStreamEntryWebSockets",
    id: string,
    caseId: string,
    text?: string | null,
    createdBy?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    createdOn: string,
    locationNum: string,
    downloadURL?: string | null,
    fileName?: string | null,
    mimeType?: string | null,
  } | null,
};

export type AddedActivityStreamEntrySummaryViewSubscriptionVariables = {
  locationNum?: string | null,
};

export type AddedActivityStreamEntrySummaryViewSubscription = {
  addedActivityStreamEntrySummaryView?:  {
    __typename: "ActivityStreamEntryWebSockets",
    id: string,
    caseId: string,
    text?: string | null,
    createdBy?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    createdOn: string,
    locationNum: string,
    downloadURL?: string | null,
    fileName?: string | null,
    mimeType?: string | null,
  } | null,
};

export type UpdatedCaseSubscriptionVariables = {
  locationNum?: string | null,
  id?: string | null,
  fieldMutated?: string | null,
};

export type UpdatedCaseSubscription = {
  updatedCase?:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  } | null,
};

export type UpdatedCaseSummaryViewSubscriptionVariables = {
  locationNum?: string | null,
  fieldMutated?: string | null,
};

export type UpdatedCaseSummaryViewSubscription = {
  updatedCaseSummaryView?:  {
    __typename: "Case",
    id: string,
    number: string,
    confidential: boolean,
    status: CaseStatus,
    description: string,
    longDescription: string,
    assignedTo?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    contact?:  {
      __typename: "User",
      id: string,
      firstName: string,
      lastName?: string | null,
      fullName?: string | null,
      guid?: string | null,
      userName?: string | null,
      audience: Audience,
      personId?: string | null,
      photoURL?: string | null,
      photo?: string | null,
      mobilePhone?: string | null,
      email?: string | null,
      title?: string | null,
    } | null,
    commentsAll?: string | null,
    openedOn: string,
    updatedOn: string,
    closedOn?: string | null,
    locationNum?: string | null,
    fieldMutated?: string | null,
    requestedItem?:  {
      __typename: "RITM",
      id?: string | null,
      number: string,
      requestOptions?:  Array< {
        __typename: "Option",
        label?: string | null,
        supportingLabels?: Array< string | null > | null,
        value?: string | null,
        filterSets?: Array< string | null > | null,
        matches?: Array< string | null > | null,
        hiddenMatches?: Array< string | null > | null,
      } | null > | null,
    } | null,
    submissionDetails?:  Array< {
      __typename: "Option",
      label?: string | null,
      supportingLabels?: Array< string | null > | null,
      value?: string | null,
      filterSets?: Array< string | null > | null,
      matches?: Array< string | null > | null,
      hiddenMatches?: Array< string | null > | null,
    } | null > | null,
    activityStream:  Array<( {
        __typename: "ActivityStreamComment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        translatedText?: string | null,
      } | {
        __typename: "ActivityStreamAttachment",
        id: string,
        caseId: string,
        text?: string | null,
        createdBy?:  {
          __typename: string,
          id: string,
          firstName: string,
          lastName?: string | null,
          fullName?: string | null,
          guid?: string | null,
          userName?: string | null,
          audience: Audience,
          personId?: string | null,
          photoURL?: string | null,
          photo?: string | null,
          mobilePhone?: string | null,
          email?: string | null,
          title?: string | null,
        } | null,
        createdOn: string,
        locationNum?: string | null,
        downloadURL: string,
        fileName: string,
        mimeType: string,
      }
    ) | null > | null,
    canRequestUpdate: boolean,
    willCloseOn?: string | null,
    isUnread?: boolean | null,
    promptTypes?: Array< CasePromptType | null > | null,
  } | null,
};

export type AddedAnnouncementSubscriptionVariables = {
};

export type AddedAnnouncementSubscription = {
  addedAnnouncement?:  {
    __typename: "Announcement",
    id: string,
    title?: string | null,
    summary?: string | null,
    category: AnnouncementCategory,
    updatedOn: string,
    hasBeenUpdated?: boolean | null,
    url?: string | null,
    outagePageURL?: string | null,
    majorCaseId?: string | null,
    isUnread: boolean,
    isExpired: boolean,
  } | null,
};
